// /*
// ==============================
// Variables
// ==============================
// */

// window.no = __(__.isUndefined).bind(__);
// window.defined = function() {
//     return !no.apply(__, arguments)
// }

// window.nop = function() {};
// window.I = function(val) { return val; };

// window.bbva = window.bbva || {};
// bbva.tools = bbva.tools || {};

// var media = {
//     mobile:  480,
//     tablet:  799,
//     desktop: 800
// };

// var timer_resize;

// /*
// ==============================
// Functions
// ==============================
// */

// //----

// (function() {
//     /**
//      * Return IE version if applies, -1 otherise
//      *
//      * Works with all IE versions.
//      */
//     function getIEVersion() {

//         if (!getIEVersion.version) {

//             // match MSIE for IE <= 9, Trident for IE >= 10
//             var match = navigator.userAgent
//                 .match(/(?:MSIE |Trident\/.*; rv:)(\d+)/);

//             // get the captured major version number
//             getIEVersion.version = match ? parseInt(match[1]) : undefined;
//         }

//         return getIEVersion.version;
//     }

//     // register the function for global access
//     bbva.tools.getIEVersion = getIEVersion;
// })();

// //-----

//     /*
//     ---------------
//     fix line-height
//     make the line height be as tall as the height of the element
//     ---------------
//     */

//     $.fn.extend({
//         fixLineHeight: function() {
//             $(this).each(function() {
//                 var $node = $(this);
//                 $node.css('line-height', $node.outerHeight());
//                 $node.on('heightChange', function() {
//                     $node.css('line-height', $node.outerHeight());
//                 })
//             });
//         }
//     });

//     $('.fix-line-height').fixLineHeight();

//     /*
//     ---------------
//     bgCenterImg
//     @by: Fer
//     Center image to fit the whole container
//     ---------------
//     */

//     $.fn.extend({
//         bgCenterImg: function(minToApply, maxToApply) {

//             // if no images, abort
//             if (!this.length) return;

//             // center each image
//             this.each(__center);

//             /**
//              * Center an image into it's parent.
//              *
//              * Given a HTMLElement node, find it's parent node, and find
//              * the first image child node; then, apply a background to the
//              * parent using the image, using css cover.
//              *
//              * It is possible to use an ancestor as parent: by issuing a
//              * data-bg-ancestor number, the parent becomes an ancestor of
//              * the default parent, going up that number of times.
//              *
//              * This function will be recalled every time there is a media
//              * jump, for example from tablet to desktop or from desktop
//              * to mobile.
//              *
//              * It is possible to scope the application of the centering
//              * behaviour this function provides by issuing data-bg-min
//              * and data-bg-max attributes with valid values of : "mobile",
//              * "tablet" and "desktop"
//              *
//              * Account for media query based image replacement dependant upon
//              * `img.currentSrc`, like picture node machanics for example.
//              *
//              * @param      {HTMLElement}  el      the image or picture node.
//              */
//             function __center(i, el) {
//                 var $node = $(el);
//                 var $parent = $node.parent();
//                 var currDeviceWidth;
//                 var lastDeviceWidth = $node.data('last-device-width');
//                 var mediaJumpEventRegistered = $node
//                     .data('media-jump-event-registered');
//                 var dontApply = false;
//                 var minToApply = $node.data('bg-min');
//                 var maxToApply = $node.data('bg-max');
//                 var nAncestor = $node.data('bg-ancestor');

//                 // if we have no parent, we can abort
//                 if (!$parent.length) return;

//                 // should we use an ancestor as parent?
//                 if (nAncestor) {
//                     nAncestor = parseInt(nAncestor);

//                     // parseable as an int, adjust parent
//                     if (nAncestor) {
//                         __(nAncestor).times(function() {
//                             var $newParent = $parent.parent();

//                             // if there's no ancestor, abort
//                             if (!$newParent.length) return;

//                             $parent = $newParent;
//                         });
//                     }
//                 }


//                 // NOTE: we need to reexecute this function with this params
//                 // when there's a media query jump


//                 // store if we are on desktop, tablet or mobile
//                 if (Modernizr.mq('(min-width: ' + media.desktop + 'px)')) {
//                     currDeviceWidth = 'desktop';
//                 } else if (Modernizr.mq('(min-width: ' +
//                         media.tablet + 'px)')) {
//                     currDeviceWidth = 'tablet';
//                 } else {
//                     currDeviceWidth = 'mobile';
//                 }


//                 // NOTE: at the end of the function we'll need to persist the
//                 // currDeviceWidth as the lastDeviceWidth


//                 // register the event on resize, but only if we haven't
//                 // already done so
//                 if (!mediaJumpEventRegistered) {
//                     $(window).on('resize', function(event) {
//                         // if the device width is different, we're on a media
//                         // jump, recall this __center function with the
//                         // params
//                         if (currDeviceWidth !== lastDeviceWidth) {
//                             __center(i, el);
//                         }
//                     });

//                     // persist that we have registered the event
//                     $node.data('media-jump-event-registered', true);
//                 }

//                 // figure out if we should apply centering or not;
//                 // if not, make shure we undo side-effects
//                 //
//                 // What makes dontApply true:
//                 //     -   on mobile, min is tablet or desktop
//                 //     -   on tablet, max is mobile or min is desktop
//                 //     -   on desktop, max is mobile or tablet
//                 dontApply =
//                     // mobile
//                     (currDeviceWidth === 'mobile' && (
//                         minToApply === 'tablet' ||
//                         minToApply === 'desktop'
//                     )) ||

//                     // tablet
//                     (currDeviceWidth === 'tablet' && (
//                         maxToApply === 'mobile' ||
//                         minToApply === 'desktop'
//                     )) ||

//                     // desltop
//                     (currDeviceWidth === 'desktop' && (
//                         maxToApply === 'mobile' ||
//                         maxToApply === 'tablet'
//                     ))
//                 ;

//                 // if we shouldn't apply, undo side-effects and return
//                 if (dontApply) {
//                     // assume no other js is styling our things
//                     $parent.removeAttr('style');
//                     $node.removeAttr('style');

//                     return;
//                 }


//                 // NOTE: following this point, apply the bg centering


//                 var $img = $node; // we begin asuming the node is an img
//                 var nAncestor = $node.data('bg-ancestor');
//                 var img; // the actual img node
//                 var url; // will hold the img src,

//                 // apply default styles to the parent element. In order
//                 // to override inline styles, we can combine !important with
//                 // an attribute selector that matches [style] in the css
//                 $parent.css({
//                     backgroundPosition: 'center 0%',
//                     backgroundSize: 'cover',
//                     backgroundRepeat: 'no-repeat',
//                     backgroundOrigin: 'border-box',
//                     backgroundColor: 'transparent'
//                 });

//                 // if node is not img, get the img
//                 if ($node[0].nodeName.toLowerCase() !== 'img') {

//                     // find the imgs contained (we'll use the first one)
//                     $img = $node.find('img');

//                     // if no img is found, we can abort
//                     if (!$img.length) return;
//                 }

//                 // get the real img node
//                 img = $img[0];

//                 // get the url ( account for new srcset stuff)
//                 url = img.currentSrc || img.src;

//                 // // if currentSrc does exist, we'll need to update the url
//                 // // when it changes
//                 // img.currentSrc && $(window).on('resize', function() {

//                 //     // if currentSrc didn't change we can abort
//                 //     if (url === img.currentSrc) return;

//                 //     // update the url
//                 //     url = img.currentSrc;

//                 //     // update the css url
//                 //     $parent.css({ backgroundImage: 'url(' + url + ')' });
//                 // });

//                 // hide the img or picture element with opacity
//                 if ($node.css('position') !== 'absolute') {
//                     $node.css('position', 'relative');
//                 }

//                 $node.css({
//                     opacity: 0,
//                     zIndex: -1
//                 });

//                 // set the url for the background image
//                 $parent.css({ backgroundImage: 'url(' + url + ')' });

//                 // presist currDeviceWidth as lastDeviceWidth
//                 $node.data('last-device-width', currDeviceWidth);
//             }
//         }
//     });

//     // on document ready, center all images that were flagged by a class
//     $(function() {
//         $('.bg-center-img').bgCenterImg();
//     });

//     /*
//     ---------------
//     fixGridHeight
//     Put same height in elements with the same childs
//     ---------------
//     */
//         $.fn.extend({
//             // Get number of columns
//             getColsNum : function() {
//                 var cols = 0,
//                     line_top = 0;

//                 try{
//                     line_top = $(this).first().offset().top;
//                 }catch(e) {
//                     console.log(e);
//                 }

//                 $(this).each(function() {
//                     if ($(this).offset().top != line_top) return false;
//                     cols++;
//                 });

//                 return cols;
//             }
//         });

//         $.fn.extend({
//             // Match rows heights per columns
//             fixGridHeight : function() {
//                 var cols_num = $(this).getColsNum();

//                 for (var i = 0; i < $(this).length; i += cols_num) {
//                     var row = $(this).slice(i, i + cols_num),
//                         heights = [];

//                     row.each(function(i) {
//                         var row_childs = ($(this).find('.fix-height-elm').length > 0 ? $(this).find('.fix-height-elm') : $(this).children());

//                         if (cols_num >= 2) {
//                             row_childs.each(function(j) {
//                                 $(this).css('height', 'auto');

//                                 var h = $(this).outerHeight();

//                                 if (typeof heights[j] == 'undefined') heights.push(h);
//                                 else if (h > heights[j]) heights[j] = h;
//                             });

//                             if (i == row.length-1) {
//                                  row.each(function() {
//                                     row_childs = ($(this).find('.fix-height-elm').length > 0 ? $(this).find('.fix-height-elm') : $(this).children());
//                                     row_childs.each(function(j) {
//                                         $(this).css('height', heights[j]);
//                                     });
//                                  });
//                             }
//                         }
//                         else {
//                             row_childs.each(function() {
//                                 $(this).css('height', 'auto');
//                             });
//                         }
//                         $(this).css('opacity', 1);
//                     });
//                 }
//             }
//         });

//         function checkFixGridHeight() {
//             if ($('.fix-grid-height').length > 0) {
//                 $('.fix-grid-height').each(function() {
//                     var $fixHeight = $(this).find('.fix-height');
//                     if ($fixHeight.length && $fixHeight.is(':visible')) $fixHeight.fixGridHeight();
//                 });
//             }
//         }

//     /*
//     ---------------
//     Fix heights V2
//     ---------------
//     */
//         var fixHeights = {
//             elm            : '.fh-elm',         // Elements selector
//             parts          : '.fh-part',        // Element's parts selector to fix heights
//             dataFixed      : 'data-fh-fixed',   // Element's boolean to check heights
//             updateHeights  : function() {
//                 var $elms = $(this.elm),
//                     parts = this.parts,
//                     dataFixed = this.dataFixed,
//                     fh = this;

//                 $elms.attr(dataFixed, false);
//                 $elms.attr('data-fh-end', false);

//                 $elms.each(function() {
//                     if ($(this).attr(dataFixed) != 'true' && $(this).is(':visible')) {
//                         var $elm = $(this),
//                             rowElms = fh.getRowElms($elm, $elms),
//                             highestParts = fh.getHighestParts(rowElms, parts);

//                         $(rowElms).each(function() {
//                             var $rowElm = $(this),
//                                 $rowElmParts = $(this).find(parts);

//                             for (var i = 0; i < highestParts.length; i++) {
//                                 if (rowElms.length >= 2) // IF we have more than 2 elms to fix heights
//                                     $rowElmParts.eq(i)
//                                         .css('height', highestParts[i])
//                                         .trigger('heightChange')
//                                     ;
//                             }
//                             $rowElm.css('opacity', 1).attr(dataFixed, true);
//                         });
//                     }
//                 });

//                 setTimeout(function() {
//                     $elms.attr('data-fh-end', true);
//                 }, 850);
//             },
//             getRowElms: function($elm, $elms) {
//                 var top = $elm.offset().top,
//                     rowElms = [];

//                 $elms.each(function() {
//                     if ($(this).offset().top == top) rowElms.push($(this));
//                 });

//                 return rowElms;
//             },
//             getHighestParts: function(rowElms, parts) {
//                 var highestParts = [];

//                 $(rowElms).each(function() {
//                     var $parts = $(this).find(parts),
//                         rowHeights = highestParts;

//                     $parts.css('height', 'auto').each(function(i) {
//                         var partHeight = $(this).outerHeight();

//                         if (typeof rowHeights[i] === "undefined") rowHeights.push(partHeight);
//                         else if (partHeight > rowHeights[i]) {
//                             rowHeights[i] = partHeight;
//                         }
//                     });

//                     for (var i = 0; i < rowHeights.length; i++) {
//                         if (highestParts.length === 0) highestParts = rowHeights;
//                         else if (rowHeights[i] > highestParts[i]) {
//                             highestParts[i] = rowHeights[i];
//                         }
//                     }
//                 });

//                 return highestParts;
//             }
//         };

//     /*
//     ---------------
//     centrarImagenVertical
//     @by: Rafa
//     Center image to fit the whole container
//     ---------------
//     */
//         $.fn.extend({
//             centrarImagenVertical: function() {
//                 if(this.length){
//                     return this.each(function() {
//                         var that = this;
//                             $(that).css({"margin-top":"","margin-left":"", "top":"","left":"","width":"","height":"", "opacity":"1", "filter": "alpha(opacity=100)"}).removeAttr("width").removeAttr("height");
//                               var ancho_imagen = $(that).outerWidth(true) * ($(that).parent().outerHeight(true) / $(that).outerHeight(true));
//                               var padre = $(that).parent();
//                               if( $(that).parent().outerWidth(true) >= ancho_imagen ){ // si la imagen al ponerla 100% de altura de la caja contenedora cubre todo el area se hace la primera condición sino la segunda
//                                 var porcentajeHeight= $(that).parent().outerWidth(true)/$(that).width();
//                                 var altojustado= $(that).height()*porcentajeHeight;
//                                 $(that).css({"width":"100%", "height": altojustado +"px"});
//                                 if (Math.floor(padre.outerHeight(true)) != Math.floor($(that).outerHeight(true))){
//                                     var alineacion_vertical_imagen = padre.data("alineacionverticalimagen");
//                                     var alineacion_v = alineacion_vertical_imagen !== undefined ? alineacion_vertical_imagen : "top";
//                                     switch (alineacion_v){
//                                         case "top":
//                                             {
//                                                 $(that).css({"top":"0" ,"margin-top":"0", "bottom":"inherit"});
//                                                 break;
//                                             }
//                                         case "bottom":
//                                             {
//                                                 $(that).css({"top":"inherit" ,"bottom":"0" ,"margin-top":"0"});
//                                                 break;
//                                             }
//                                         case "middle":
//                                             {
//                                                 $(that).css({ "bottom":"inherit", "top":"50%" ,"margin-top":"-"+(altojustado/2)+"px"});
//                                                 break;
//                                             }
//                                     }
//                                 }
//                             }else{
//                                 var alineacion_horizontal_imagen = padre.data("alineacionhorizontalimagen");
//                                 var alineacion_h = alineacion_horizontal_imagen !== undefined ? alineacion_horizontal_imagen : "center";
//                                 var porcentajeWidth= $(that).parent().outerHeight(true)/$(that).height();
//                                 var anchoAjustado= $(that).width()*porcentajeWidth;
//                                 $(that).css({"width": anchoAjustado + "px", "height":"100%", "top":"0"});
//                                 switch (alineacion_h){
//                                         case "left":
//                                             {
//                                                 $(that).css({"left":"0","right": "initial"});

//                                                 break;
//                                             }
//                                         case "right":
//                                             {
//                                                 $(that).css({"right":"0","left": "initial"});
//                                                 break;
//                                             }
//                                         case "center":
//                                             {
//                                                 $(that).css({"left":"50%", "margin-left":"-"+(anchoAjustado/2)+"px"});
//                                                 break;
//                                             }
//                                     }
//                             }
//                             var ancho = $(that).outerWidth(true) > 0 ? $(that).outerWidth(true) : 1200;//esto es para gtmetrix porque no carga bien el ancho cuando lo analiza
//                             var alto = $(that).outerHeight(true) > 0 ? $(that).outerHeight(true) : padre.outerHeight(true);
//                             $(that).attr({"width":ancho,"height":alto});

//                     });
//                 }
//             }
//         });

//         function checkCentrarImagenVertical() {
//             $('.img-fit-desktop').each(function(i, el) {
//                 var $img = $(el).children('img');

//                 // do that thing
//                 if (window.innerWidth >= media.tablet) {
//                     $img.centrarImagenVertical();
//                     return;
//                 }

//                 // if we're not in desktop, remove inline crap,
//                 // other clases like img-fit may be doing stuff, but
//                 // those classes should not be used in conjuntion
//                 // with this one.
//                 $img.attr('style', '').attr('width', '').attr('height', '');
//             });

//             $('.img-fit').each(function() {
//                 if (window.innerWidth >= 480) {
//                     $(this).children('img').centrarImagenVertical();
//                 }
//                 else if (!$(this).hasClass('img-fit-sm')) {
//                     $(this).children('img').attr('style', '').attr('width', '').attr('height', '');
//                 }
//             });
//             $('.img-fit-sm').each(function() {
//                 if (window.innerWidth < 480) {
//                     $(this).children('img').centrarImagenVertical();
//                 }
//                 else if (!$(this).hasClass('img-fit')) {
//                     $(this).children('img').attr('style', '').attr('width', '').attr('height', '');
//                 }
//             });
//         }

//     /*
//     ---------------
//     Paned
//     Title with dropdown content
//     ---------------
//     */
//         $(function() {
//             $('.paned-title').on('click', function(e) {
//                 e.preventDefault();

//                 $(this).next().slideToggle().promise().done(function() {
//                     $(this).parent().toggleClass('paned-active');
//                     onGlobalResize();
//                 });
//             });
//         });
//     /*
//     ---------------
//     Common functions
//     ---------------
//     */
//         function setHash(hash) {
//             var curHash = window.location.hash;

//             if (hash != curHash) {
//                 if (history.pushState) {
//                     history.pushState(null, null, hash);
//                 }
//                 else {
//                     location.hash = hash;
//                 }
//             }
//         }

//         var isMobile = {
//             Android: function() {
//                 return navigator.userAgent.match(/Android/i);
//             },
//             BlackBerry: function() {
//                 return navigator.userAgent.match(/BlackBerry/i);
//             },
//             iOS: function() {
//                 return navigator.userAgent.match(/iPhone|iPad|iPod/i);
//             },
//             Opera: function() {
//                 return navigator.userAgent.match(/Opera Mini/i);
//             },
//             Windows: function() {
//                 return navigator.userAgent.match(/IEMobile/i);
//             },
//             any: function() {
//                 return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
//             }
//         };

// /*
// ==============================
// Events
// ==============================
// */
//     function onGlobalResize() {
//         checkCentrarImagenVertical();
//         checkFixGridHeight();
//         fixHeights.updateHeights();
//     }

//     $(window).on('resize', function() {
//         clearTimeout(timer_resize);
//         timer_resize = setTimeout(onGlobalResize, 150);
//     });

//     $('html').on ('DOMMouseScroll mousewheel', function (e) {
//         $('html, body').stop();
//     });

// /*
// ---------------
// Document ready
// ---------------
// */
//     $(function() {
//         checkFixGridHeight();
//         checkCentrarImagenVertical();
//         $(window).load(function() {
//             checkFixGridHeight();
//             checkCentrarImagenVertical();
//             fixHeights.updateHeights();
//         });
//     });
"use strict";
"use strict";

$(function () {
	if ($("section.accordionCoronita").length > 0) {
		$(".accordionCoronita-item-title").click(function () {
			if ($(this).parent().parent().hasClass("activeAccordion")) {

				$(this).parent().parent().removeClass("activeAccordion");
				$(this).parent().parent().find(".accordionCoronita-item-answer").css({ "max-height": "1px", "min-height": "1px" });
			} else {
				$(".accordionCoronita-item.activeAccordion").find(".accordionCoronita-item-answer").css({ "max-height": "1px", "min-height": "1px" });
				$(".accordionCoronita-item").removeClass("activeAccordion");
				$(this).parent().parent().addClass("activeAccordion");
				var heightAccordionQuestion = $(this).parent().parent().find(".accordionCoronita-item-answer-container").innerHeight();
				$(this).parent().parent().find(".accordionCoronita-item-answer").css({ "max-height": heightAccordionQuestion, "min-height": heightAccordionQuestion });
			}

			if ($(".accordionCoronita-item.activeAccordion").length > 0) {
				setTimeout(function () {
					$('html, body').animate({
						scrollTop: $(".accordionCoronita-item.activeAccordion").offset().top
					}, 300);
				}, 400);
			} else {
				$('html, body').animate({
					scrollTop: $("section.accordionCoronita").offset().top
				}, 300);
			}
		});
	}
});
'use strict';

$(function () {
  $(".anclaNextSection").click(function () {
    $('html, body').animate({
      scrollTop: $(this).closest('section').next().offset().top
    }, 1000);
  });
});
'use strict';

$(function () {

    //==========================================================================
    // STATE
    //==========================================================================

    //-----

    /**
     * The components
     *
     * jQuery collection of section nodes that map to the component instances.
     *
     * @type       {jQuery}
     */
    var $components;

    //-----

    /**
     * The window object wrapped in jQuery.
     *
     * @type       {jQuery}
     */
    var $window;

    //-----

    //==========================================================================
    // ENTRY POINT
    //==========================================================================

    init();

    //==========================================================================
    // INIT
    //==========================================================================

    //-----

    /**
     * Get things rolling
     *
     * This is the function that will execute this module's logic. It's the
     * first and only statement in the module.
     */
    function init() {

        // init rest of shared state
        initState();

        // if there are no components, we're done
        if (!$components.length) return;

        // otherwise, for each component, do stuff
        $components.each(manageComponent);
    }

    //-----

    //==========================================================================
    // FUNCTIONS
    //==========================================================================

    //===== NOT EVENTS =====================================================

    //-----

    /**
     * Init the rest of shared state
     *
     * Any state variable that common to all component instances, is not
     * the `$components` collection, and does not depend on loops like the
     * primary `manageComponent` one, will be initialized by this function.
     */
    function initState() {

        // the window object
        $window = $(window);

        // get components on the page
        $components = $('section.banner-bancomer');
    }

    //-----

    /**
     * Manage the logic for each component
     *
     * This is the primary controller function for a component. It orchestrates
     * the component's behaviour.
     *
     * @param      {number}  i          The component index in the `$components`
     *                                  collection. Unused.
     * @param      {<type>}  component  The component.
     */
    function manageComponent(i, component) {

        var $component = $(component);
        var $topBox = $component.find('.top-on-mobile');
        var $bottomBox = $component.find('.bottom-on-mobile');
        var handler;

        // init data scoped to the component
        initComponentData($component);

        // build handler for updating the top box height; we'll bind some
        // references to it's scope using partial aplication, and debounce
        // it's executtion a bit
        handler = __.debounce(__.partial(evtComponentH, __, $component, $topBox, $bottomBox), 80);

        // register the handler
        $window.on('resize.bannerBancomer heightChange', handler);

        // trigger resize
        $window.trigger('resize.bannerBancomer');
    }

    //-----

    function initComponentData($component) {

        // init last-width
        $component.data('last-width', $window.width());

        // init flag for is first draw
        $component.data('is-first-draw', true);

        // init flag for picture height usage
        $component.data('use-picture-height', false);
    }

    //-----

    function getDesktopHeight($component, $topBox, $bottomBox) {

        var desktopH = $component.data('desktop-height');
        var usePictureH = $component.data('use-picture-height');
        var pictureH = $topBox.find('picture').height();
        var bottomBoxH = $bottomBox.height();
        var topBoxH;
        var tmp;

        // if the height has been overridden, use that
        if (desktopH) return desktopH;

        // else, if the picture height should be used, try to use it
        if (usePictureH) return Math.max(pictureH, bottomBoxH);

        // else, first get the topBoxH; in order for the resize not to show a
        // broken layout, restore the current height on the same event loop, so
        // that the debounced functions don't let the user see everything out of
        // place
        //
        // BROKEN: it is somehow leaking anyway, on resize and on other scenarios
        // the scroll is jumping. Let's try to set the component height during
        // the auto time
        tmp = $topBox.height();
        // try to avoid side effects due to setting height to auto in top-box
        $component.height($component.height());
        $topBox.height('auto');
        topBoxH = $topBox.height();
        $topBox.height(tmp);
        $component.height('auto');
        tmp = undefined;

        // then, add top and bottom box heights
        return topBoxH + bottomBoxH;
    }

    //-----

    function hidePicture($component, $topBox, currWidth) {

        var currWidth = $window.width();
        var $picture = $component.find('picture');
        var $content = $component.find('.row.title-block', '.row.iframe');
        var pictureH = $picture.height(); // 0 if hidden

        // we use the hide class instead of $.show() because there are other
        // CSS rules and situations that may hide the picture
        if (currWidth < media.desktop) {
            $picture.removeClass('hide');
            return;
        }

        // there's either iframe or text-block visible on the top side,
        // hide the picture
        if (pictureH && $content.length) {
            $picture.addClass('hide');
            return;
        }

        // when there's no content visible on the top side, picture's height is
        // not 0; in this scenario, we flag the use of the picture height for
        // the height of the top box
        if (pictureH && !$content.length) {
            $component.data('use-picture-height', true);
        }
    }

    //-----

    //===== EVENTS =========================================================

    //-----

    function evtComponentH(event, $component, $topBox, $bottomBox) {

        var currWidth = $window.width();
        var lastWidth = $component.data('last-width');
        var wasDesktop = lastWidth >= media.desktop;
        var isDesktop = currWidth >= media.desktop;
        var isFirstDraw = $component.data('is-first-draw');
        var isHeightChange = event.type === 'heightChange';

        // we can now set first draw to false
        $component.data('is-first-draw', false);

        // remove js-hide class
        if ($component.hasClass('js-hide')) $component.removeClass('js-hide');

        // if needed, hide picture
        hidePicture($component, $topBox, currWidth);

        // let the top box height adjust to it's content
        if (!isDesktop) {
            $topBox.height('auto');
        }

        // if the height must be as in desktop
        else if (isFirstDraw || isHeightChange || !wasDesktop) {
                $topBox.height(getDesktopHeight($component, $topBox, $bottomBox));
            }

        // on iframe height change, we may need to reset topBox height
        // they will fire 'iframe-height-change' with an iframe reference
        $window.on('iframe-height-change', function (event, iframe) {
            // return if not our iframe
            if ($component.find('iframe')[0] !== iframe) return;

            // get the iframe height
            var $iframe = $(iframe);
            var currHeight = $iframe.height();

            // init persistent iframe height storage
            if (__.isUndefined($topBox.data('iframeH-last'))) {
                $topBox.data('iframeH-last', -1);
            }

            // get iframe last height
            var lastHeight = $topBox.data('iframeH-last');

            // if curr height didn't change, we're done
            if (currHeight === lastHeight) return;

            // otherwise, recalc $topBox height and store new last height
            $topBox.height(getDesktopHeight($component, $topBox, $bottomBox));
            $topBox.data('iframeH-last', currHeight);
        });

        // update last-width
        $component.data('last-width', currWidth);
    }

    //-----
});
"use strict";

$(document).ready(function () {
	navegacionBannerListadoComercial();
	$(window).resize(function () {
		navegacionBannerListadoComercial();
	});

	function navegacionBannerListadoComercial() {
		if ($(window).width() > 799) {
			$("section.banner-listado-comercial .swiper").hover(function () {
				$(this).find(".swiper-button-prev").fadeIn();
				$(this).find(".swiper-button-next").fadeIn();
			}, function () {
				$(this).find(".swiper-button-prev").fadeOut();
				$(this).find(".swiper-button-next").fadeOut();
			});
		}

		$("section.banner-listado-comercial .swiper-button-prev").hover(function () {
			$("section.banner-listado-comercial .swiper-button-prev").animate({ backgroundSize: '80%' }, 1);
		}, function () {
			$("section.banner-listado-comercial .swiper-button-prev").animate({ backgroundSize: '60%' }, 1);
		});

		$("section.banner-listado-comercial .swiper-button-next").hover(function () {
			$("section.banner-listado-comercial .swiper-button-next").animate({ backgroundSize: '80%' }, 1);
		}, function () {
			$("section.banner-listado-comercial .swiper-button-next").animate({ backgroundSize: '60%' }, 1);
		});
	}
});
"use strict";

$(function () {
	if ($('section.bannerBottomFixed').length > 0) {
		$("section.bannerBottomFixed").find(".bannerBottomFixed-close").click(function () {
			$("section.bannerBottomFixed").remove();
		});
	}
});
'use strict';

$(function () {
    var $titleWrapper = $('.title-wrapper');

    // set line height for vetical align
    $titleWrapper.each(function (i, el) {
        var $el = $(el);

        $el.css({
            lineHeight: $el.outerHeight() + 'px'
        });
    });
});
'use strict';

$(function () {

    //==========================================================================
    // MODULE STATE
    //==========================================================================

    var docEl;
    var $window;
    var $document;
    var $components;

    //==========================================================================
    // ENTRY POINT
    //==========================================================================

    init();

    //==========================================================================
    // INIT
    //==========================================================================

    //-----

    function init() {
        // init module state
        initModuleState();

        // if there are no related components on the page, return
        if (!$components.length) return;

        // for each component, do stuff
        __($components).each(manageComponent);
    }

    //-----

    //==========================================================================
    // FUNCTIONS
    //==========================================================================

    //-----

    function initModuleState() {
        $window = $(window);
        $document = $(document);
        $components = $('section.contenido-basico-v2');
        docEl = document.documentElement;
    }

    //-----

    function manageComponent(component) {
        var $component = $(component);
        $component.find('[data-background]').each(function (i, el) {
            var $el = $(el);
            $el.css('background-image', 'url(' + $el.data('background') + ')');
        });
    }

    //-----
});
// // MOVIDO A "site-extensions.js" en el viejo repositorio

// $(function() { // create module scope

// //======================================================================
// // STATE
// //======================================================================

// /**
//  * The components.
//  *
//  * jQuery collection of section nodes that map to the component instances.
//  *
//  * @type       {jQuery}
//  */
// var $components;

// /**
//  * The current component.
//  *
//  * The current component, if there are more than one in the page.
//  *
//  * @type       {jQuery}
//  */
// var $currComponent;

// /**
//  * An object with the pdf data.
//  *
//  * The object has two properties. There is a "fields" object that can
//  * contain keys "institution", "year" and "quarter", with data like for
//  * example a name property with a translated string for the label in the UI.
//  * If false or missing, they will neither be rendered in the UI nor be
//  * provided with values in the pdf documents; otherwise they will map to
//  * selects in the UI.
//  *
//  * The other "documents" property is an array of pdf document objects with
//  * two always required fields: "institution" and "url", and optionally, year
//  * or quarter, if they were not false or missing, as described above.
//  *
//  * Example:
//  * ```js
//  * pdf = {
//  *     fields: {
//  *         institution: {
//  *             name: 'Institución'
//  *         },
//  *         year: {
//  *             name: 'Año'
//  *         },
//  *         quarter: false
//  *     },
//  *     documents: [
//  *         {
//  *             institution: 'Aha',
//  *             year: 2001,
//  *             quarter: 1,
//  *             url: '/fbin/mult/inversionistas/2001.pdf'
//  *         }
//  *     ]
//  * };
//  * ```
//  *
//  * @type       {Object}
//  */
// var pdf;

// /**
//  * The select markup for a field present in the pdf.fields object
//  *
//  * Since the institution is required, it comes server-rendered. We will
//  * grab it's related node, and use it as a template for any other
//  * required fields.
//  *
//  * @type       {JQuery}
//  */
// var $selectTemplate;

// //======================================================================
// // ENTRY POINT
// //======================================================================

// init();

// //======================================================================
// // INIT
// //======================================================================

// //-----

// /**
//  * Get things rolling
//  *
//  * This is the function that will execute this module's logic. It's the
//  * only call there is in this script and that call is the last statement
//  * of the module.
//  */
// function init() {

//     // get the components
//     $components = $('section.contenido-formulario-inversionistas');

//     // get the pdf object
//     pdf = getPdf();

//     // if we've got no copmonent or no pdf, we're done
//     if (!$components.length || !pdf) return;

//     // init the $selectTemplate
//     $selectTemplate = $components.eq(0).find('form label').clone();

//     // manage each component
//     $components.each(manageEachComponent);
// }

// //-----

// //======================================================================
// // FUNCTIONS
// //======================================================================

// //-----

// /**
//  * Get the pdf object
//  *
//  * The pdfs come from tridion, through a js global variable that lives
//  * in `window.bbva`, called `pdf`; so `window.bbva.pdf` must contain the
//  * pdf object at the time this script executes.
//  *
//  * @return     {mixed}  The pdf object, or false if no pdf object.
//  */
// function getPdf() {
//     if (!window.bbva || !window.bbva.pdf) return false;
//     return window.bbva.pdf;
// }

// //-----

// /**
//  * Manage each component
//  *
//  * For each component, paint and hook up the different select options with
//  * the pdf object.
//  *
//  * @param      {number}       i   The component index in the copmonents
//  *                                collection.
//  * @param      {HTMLElement}  el  The component section node.
//  */
// function manageEachComponent(i, component) {

//     var $component = $(component),
//         $button    = $component.find('button'),
//         $selects   = $component.find('.selects'),
//         selects    = { institution: $component.find('select').eq(0) }
//     ;

//     // update the current component.
//     $currComponent = $component;

//     // draw fields
//     __(pdf.fields).each(__(drawField).partial(__, __, __, $selects,
//         selects));

//     // add options
//     __(pdf.documents).each(__(addSelectOptions).partial(__, __, __,
//         pdf.fields, selects));

//     // reorder year options ascending
//     reorderYearSelectOpts(selects.year);

//     // manage institution change
//     selects.institution.on('change', __(eInstitutionChanged).partial(__,
//         pdf.fields, selects, $button));

//     // manage year change
//     if (pdf.fields.year && selects.year) {
//         selects.year.on('change', __(eYearChanged).partial(__, pdf.fields,
//             selects, $button));
//     }

//     // manage quarter change
//     if (pdf.fields.quarter && selects.quarter) {
//         selects.quarter.on('change', __(eQuarterChanged).partial(__,
//             selects, $button));
//     }
// }

// //-----

// /**
//  * Draws a field.
//  *
//  * A field is represented in the UI as a select. First, clone the select
//  * template for a field representation, or in the case of institution,
//  * reference the server rendered select node. Then, grab the provided name
//  * from the given field data object and add it to the cloned node. Last,
//  * store areference to the new select in the provided selects object.
//  *
//  * @param      {mixed}    fieldKey   The field key.
//  * @param      {number}   field      The field value or fale.
//  * @param      {array}    fields     The fields object.
//  * @param      {jQuery}   $selects   The selects jQuery collection.
//  * @param      {object}   selects    A map with references to the selects.
//  */
// function drawField(field, fieldKey, fields, $selects, selects) {

//     // if the field is not present, don't draw it's select
//     if (!field) return;

//     // grab the name
//     var name = field.name;

//     // grab de text for the default option
//     var defaultText = field.default ||
//         fields.institution && fields.institution.default;

//     // chose the institution select, or clone the select template.
//     var $select = (fieldKey === 'institution')
//         ? $currComponent.find('form label').eq(0)
//         : $selectTemplate.clone()
//     ;

//     // create and append the select
//     $select
//         .find('.js-name')
//             .text(name)
//             .end()
//         .find('select')
//             .attr('name', fieldKey)
//             .prop('disabled', fieldKey !== 'institution')
//             .end()
//         .appendTo($selects)
//     ;

//     // set the default option text if found
//     $select.find('option.default').text(defaultText);

//     // store a reference to the select
//     selects[fieldKey] = $select.find('select');
// }

// //-----

// /**
//  * Add the options to their select boxes, and store the url
//  *
//  * Given a pdf document, add the options that represent this document
//  * in the selects of the UI. The url will be stored in the option that is
//  * most leaf-like for the given pdf object: if there are quarters in
//  * the quarter, if not, in the year, etc.
//  *
//  * @param      {object}  doc      The document object.
//  * @param      {number}  i        An unused index, there for signature
//  *                                reasons. It's the document position in
//  *                                the documents array.
//  * @param      {array}   docs     The documents array.
//  * @param      {object}  fields   The fields object.
//  * @param      {jQuery}  selects  The selects jQuery nodes.
//  */
// function addSelectOptions(doc, i, docs, fields, selects) {

//     var $option;
//     var test = doc.institution === 'BBVA Bancomer (english)';

//     // add intitution option
//     $option = createOption(selects.institution, doc, true, 'institution');

//     // add year option
//     if (doc.year && selects.year) {
//         $option = createOption(selects.year, doc, false, 'year');
//     }

//     // add quarter option
//     if (doc.quarter && selects.quarter) {
//         $option = createOption(selects.quarter, doc, false, 'quarter');
//     }

//     $option.data('url', doc.url);
// }

// //-----

// *
//  * Creates an option jQuery node.
//  *
//  * Create an option for a select. The option will have a provided value,
//  * it's text will be the same as the value. If there's already an option in
//  * that select whose text is the provided value, abort. The option may be
//  * hidden or shown by default, and if provided, it can include references
//  * to the releated intitution and/or year. Once the option is created,
//  * append it to the provided select.
//  *
//  * @param      {jQuery}    $select  The select.
//  * @param      {string}    val      The value.
//  * @param      {boolean}   isShown  Indicates if shown.
//  * @param      {string}    forIns   The reference for insert
//  * @param      {string}    forYear  The reference for year
//  * @return     {jQuery}    The created jQuery option node.

// function createOption($select, doc, isShown, type) {
//     var val = doc[type] && (doc[type] + "").trim();

//     // try to find the option that we would add
//     var $option = $select
//         .find('option')
//         .filter(function(i, option) {
//             var $option = $(option);
//             var currVal = option.text.toLowerCase().trim()
//             var isSameVal = currVal === val.toLowerCase();

//             // if the option is year
//             if (isSameVal && type === 'year') {
//                 var forIns = $option.attr('data-for-institution');

//                 return forIns === doc.institution;
//             }

//             // else, if the option is quarter
//             else if (isSameVal && type === 'quarter') {
//                 var forIns = $option.attr('data-for-institution');
//                 var forYear = $option.attr('data-for-year');

//                 return forIns === doc.institution && forYear === doc.year;
//             }

//             // else it's institution
//             return isSameVal;
//         })
//     ;

//     // if it already exists, we can abort
//     if ($option.length) return $option.eq(0);

//     // create the new option
//     var $newOption = $('<option class="js-option">');

//     // set the text and value
//     $newOption.text(val).val(val);

//     // update display if needed
//     if (!isShown) $newOption.hide();

//     // add parent select relationships
//     if (type === 'year' || type === 'quarter') {
//         $newOption.attr('data-for-institution', doc.institution);
//     }

//     if (type === 'quarter') {
//         $newOption.attr('data-for-year', doc.year);
//     }

//     // add the option to the select
//     $select.append($newOption);

//     return $newOption;
// }

// //-----

// /**
//  * Reorder the options of a select.
//  *
//  * The criteria will be the value, assumed to be numeric.
//  *
//  * @param      {jQuery}  $select  The select
//  */
// function reorderYearSelectOpts($select) {
//     var $options = $select.find('option').not('.default');
//     var $ordered = $options.sort(function(pre, post) {
//         return pre.value - post.value;
//     });

//     $options.detach();
//     $select.append($ordered);
// }

// //-----

// /**
//  * Update the href of the button that opens the pdf document.
//  *
//  * @param      {boolean}  shouldDisable  Whether to disable the button.
//  * @param      {jQuery}   $button        The jQuery button node.
//  * @param      {string}   url            The new url for the pdf to link to.
//  */
// function updateButton(shouldDisable, $button, url) {
//     $button.find('a').attr('href', url || '#');
//     $button[0].disabled = shouldDisable;
// }

// //-----

// /**
//  * Disables a select.
//  *
//  * Given a jQuery select node, set it's value to "", propagate the change
//  * in value with an event, and disable the select.
//  *
//  * @param      {jQuery}  $select  The select to disable.
//  */
// function disableSelect($select) {

//     // set it's value to the empty string
//     $select.val('');

//     // trigger a change so that others can update
//     $select.trigger('change');

//     // disable the select
//     $select[0].disabled = true;
// }

// //===== EVENT HANDLERS =================================================

// //-----

// /**
//  * Manage the change event for the institution select.
//  *
//  * The function will be provided with the event object and the fields,
//  * selects and $button references.
//  *
//  * If there is no year select, grab the url from the selected option
//  * and use it to update the button. Then, if the year select should be
//  * disabled because the option chosen was the default unrelated one,
//  * do so. Otherwise, show only the year options that relate to the new
//  * institution, and enable the year select. Lastly, reset the year
//  * select value and selected option to the default undefined one and
//  * cascade this change so that everything has a chance to sync.
//  *
//  * @param      {object}  event    The event.
//  * @param      {object}  fields   The fields.
//  * @param      {object}  selects  The selects.
//  * @param      {jQuery}  $button  The button.
//  */
// function eInstitutionChanged(event, fields, selects, $button) {
//     var val = selects.institution.val();
//     var url = selects.institution.find('option:selected').data('url');

//     // if there's no year select, update button and be done
//     if (!fields.year || !selects.year) {
//         updateButton(!val, $button, url);
//         return;
//     }

//     // otherwsise, manage year select
//     // we start by hiding all the years
//     selects.year.find('.js-option').hide();

//     // we may need to disable the year select; if so, we can abort too
//     if (!val) {
//         disableSelect(selects.year);
//         return;
//     }

//     // show the options that relate to this institution
//     selects.year
//         .find('[data-for-institution="' + val + '"]')
//         .show()
//     ;

//     // enable the year select
//     selects.year[0].disabled = false;

//     // reset the year select value
//     selects.year.val('');
//     selects.year.trigger('change');
// }

// //-----

// /**
//  * Manage the change event for the year select.
//  *
//  * The function will be provided with the event object and the fields,
//  * selects and $button references.
//  *
//  * If there is no quarter select, grab the url from the selected option
//  * and use it to update the button. Then, if the quarter select should be
//  * disabled because the option chosen was the default unrelated one,
//  * do so. Otherwise, show only the quarter options that relate to the new
//  * year, and enable the quarter select. Lastly, reset the quarter
//  * select value and selected option to the default undefined one and
//  * cascade this change so that everything has a chance to sync.
//  *
//  * @param      {object}  event    The event.
//  * @param      {object}  fields   The fields.
//  * @param      {object}  selects  The selects.
//  * @param      {jQuery}  $button  The button.
//  */
// function eYearChanged(event, fields, selects, $button) {
//     var val      = selects.year.val();
//     var $currOpt = selects.year.find('option:selected');
//     var forIns   = $currOpt.attr('data-for-institution');
//     var url      = $currOpt.data('url');

//     // if there's no quarter select, update button and be done
//     if (!fields.quarter || !selects.quarter) {
//         updateButton(!val, $button, url);
//         return;
//     }

//     // otherwsise, manage quarter select
//     // we start by hiding all the quarters
//     selects.quarter.find('.js-option').hide();

//     // we may need to disable the quarter select; if so, we can abort too
//     if (!val) {
//         disableSelect(selects.quarter);
//         return;
//     }

//     // show the options that relate to this institution
//     selects.quarter
//         .find('[data-for-institution="' + forIns + '"]' +
//             '[data-for-year="' + val + '"]')
//         .show()
//     ;

//     // enable the quarter select
//     selects.quarter[0].disabled = false;

//     // reset the quarter select value
//     selects.quarter.val('');
//     selects.quarter.trigger('change');
// }

// //-----

// /**
//  * Manage the change event for the quarter select.
//  *
//  * Simply update the button with the related url.
//  *
//  * @param      {<type>}  event    The event
//  * @param      {<type>}  selects  The selects
//  * @param      {<type>}  $button  The button
//  */
// function eQuarterChanged(event, selects, $button) {
//     var val = selects.quarter.val();
//     var url = selects.quarter.find('option:selected').data('url');
//     updateButton(!val, $button, url);
// }

// //-----

// }); // close module scope
"use strict";
"use strict";

$(function () {
    if ($(".contenido-landing").length > 0) {
        var otraInformacionLanding;

        (function () {
            var contenidoOtraInformacionLAnding = function contenidoOtraInformacionLAnding() {
                $(window).trigger('resize');
            };

            otraInformacionLanding = false;

            if ($(".contenido-otra-informacion").length > 0) {
                otraInformacionLanding = true;
            }

            $('.contenido-landing').each(function () {
                $(this).find(".swiper-wrapper").css('opacity', '0');
                if ($(this).offset().top < $(window).height()) {
                    $(this).find(".contenido-title").animate({ 'opacity': '1' }, 500);
                    $(this).find(".swiper-wrapper").animate({ 'opacity': '1' }, 1000);
                    $(this).find(".btns-block").animate({ 'opacity': '1' }, 1500);
                }
            });

            /* Every time the window is scrolled ... */
            $(window).scroll(function () {
                var bottom_of_window = $(window).scrollTop() + $(window).height();
                /* Check the location of each desired element */
                $('.contenido-landing .swiper-wrapper').each(function () {

                    var bottom_of_object = $(this).offset().top + 20;
                    /* If the object is completely visible in the window, fade it it */
                    if (bottom_of_window > bottom_of_object) {
                        $(this).animate({ 'opacity': '1' }, 1000);
                    }

                    if (otraInformacionLanding) {
                        contenidoOtraInformacionLAnding();
                    }
                });

                $('.contenido-landing .contenido-title').each(function () {

                    var bottom_of_object = $(this).offset().top + 20;
                    /* If the object is completely visible in the window, fade it it */
                    if (bottom_of_window > bottom_of_object) {
                        $(this).animate({ 'opacity': '1' }, 500);
                    }

                    if (otraInformacionLanding) {
                        contenidoOtraInformacionLAnding();
                    }
                });

                $('.contenido-landing .btns-block').each(function () {

                    var bottom_of_object = $(this).offset().top + 20;
                    /* If the object is completely visible in the window, fade it it */
                    if (bottom_of_window > bottom_of_object) {
                        $(this).animate({ 'opacity': '1' }, 1500);
                    }

                    if (otraInformacionLanding) {
                        contenidoOtraInformacionLAnding();
                    }
                });
            });
        })();
    }
});
'use strict';

$(window).load(function () {
   if ($(".menu-horizontal-gris").length > 0) {
      var elementContenidoMenu = window.location.hash;
      $('a[href*=' + elementContenidoMenu + ']').trigger("click");
   }
});
'use strict';

$(function () {

    //==========================================================================
    // MODULE STATE
    //==========================================================================

    var docEl;
    var percentToShow;
    var isShown;
    var forcedHidden;
    var $window;
    var $document;
    var $components;
    var scrollHeight;
    var threshold;

    //==========================================================================
    // ENTRY POINT
    //==========================================================================

    init();

    //==========================================================================
    // INIT
    //==========================================================================

    //-----

    function init() {
        // init module state
        initModuleState();

        // if there are no related components on the page, return
        if (!$components.length) return;

        // when the scroll height changes, update the value
        $window.on('resize', updateState);

        // for each component, do stuff
        __($components).each(manageComponent);
    }

    //-----

    //==========================================================================
    // FUNCTIONS
    //==========================================================================

    //-----

    function initModuleState() {
        $window = $(window);
        $document = $(document);
        $components = $('section.contenido-otra-informacion');
        docEl = document.documentElement;
        percentToShow = 150;
        isShown = false;
        forcedHidden = false;
        scrollHeight = $document.height() - $window.height() - $("footer").height();
        threshold = scrollHeight - percentToShow;
        //sessionStorage = window.sessionStorage;
    }

    //-----

    function manageComponent(component) {
        var $component = $(component);
        var $close = $component.find('button.close');

        // on scroll manage toggling the box
        $window.on('scroll', __(manageShow).partial(__, $component));

        // on close, hide
        $close.on('click', __(hide).partial(__, $component));
    }

    //-----

    function isHidden($component) {
        return forcedHidden || canPersist($component) && !!sessionStorage[$component.attr('id')];
    }

    //-----

    function canPersist($component) {
        return !!sessionStorage && !!$component.attr('id');
    }

    //-----

    function setHidden($component) {
        // fallback for when there's no persistence
        forcedHidden = true;

        // create key for this component and this id
        canPersist($component) && (sessionStorage[$component.attr('id')] = "wasClosed");
    }

    //===== Events =============================================================

    //-----

    function updateState(event) {
        scrollHeight = $document.height() - $window.height() - $("footer").height();
        threshold = scrollHeight - percentToShow;
    }

    //-----

    function manageShow(event, $component) {
        // if it was hidden manually, do nothing
        if (isHidden($component)) return;

        // when up and shown, toggle; when down and hidden, toggle
        if (isShown === $window.scrollTop() < threshold) {
            $component.toggleClass('slide-show');
            isShown = !isShown;
        }
    }

    //-----

    function hide(event, $component) {
        $component.removeClass('slide-show');
        setHidden($component);
    }

    //-----
});
"use strict";

$(document).ready(function () {
	$(".contenido-square .contenido-round").on("click", function () {
		if ($(this).hasClass("contenido-round-1")) {
			if ($(".contenido-square .container-contenido").hasClass("showContenido1")) {
				$(".contenido-square .container-contenido").attr("class", "container-contenido showNothing");
				$(".contenido-square .background-container").css("background-image", "none");
			} else {
				$(".contenido-square .container-contenido").attr("class", "container-contenido showContenido1");
				var background = $(this).find("img.background");
				if (background.length > 0) {
					$(".contenido-square .background-container").css("background-image", "url(" + background.attr("src") + ")");
				} else {
					$(".contenido-square .background-container").css("background-image", "none");
				}
			}
		} else if ($(this).hasClass("contenido-round-2")) {
			if ($(".contenido-square .container-contenido").hasClass("showContenido2")) {
				$(".contenido-square .container-contenido").attr("class", "container-contenido showNothing");
				$(".contenido-square .background-container").css("background-image", "none");
			} else {
				$(".contenido-square .container-contenido").attr("class", "container-contenido showContenido2");
				var background = $(this).find("img.background");
				if (background.length > 0) {
					$(".contenido-square .background-container").css("background-image", "url(" + background.attr("src") + ")");
				} else {
					$(".contenido-square .background-container").css("background-image", "none");
				}
			}
		} else if ($(this).hasClass("contenido-round-3")) {
			if ($(".contenido-square .container-contenido").hasClass("showContenido3")) {
				$(".contenido-square .container-contenido").attr("class", "container-contenido showNothing");
				$(".contenido-square .background-container").css("background-image", "none");
			} else {
				$(".contenido-square .container-contenido").attr("class", "container-contenido showContenido3");
				var background = $(this).find("img.background");
				if (background.length > 0) {
					$(".contenido-square .background-container").css("background-image", "url(" + background.attr("src") + ")");
				} else {
					$(".contenido-square .background-container").css("background-image", "none");
				}
			}
		} else {
			if ($(".contenido-square .container-contenido").hasClass("showContenido4")) {
				$(".contenido-square .container-contenido").attr("class", "container-contenido showNothing");
				$(".contenido-square .background-container").css("background-image", "none");
			} else {
				$(".contenido-square .container-contenido").attr("class", "container-contenido showContenido4");
				var background = $(this).find("img.background");
				if (background.length > 0) {
					$(".contenido-square .background-container").css("background-image", "url(" + background.attr("src") + ")");
				} else {
					$(".contenido-square .background-container").css("background-image", "none");
				}
			}
		}
		$(".contenido-square").trigger("click");
	});
});
"use strict";

$(document).ready(function () {
	$(".contenido-triangular .contenido-round").on("click", function () {
		if ($(this).hasClass("contenido-round-1")) {
			if ($(".contenido-triangular .container-contenido").hasClass("showContenido1")) {
				$(".contenido-triangular .container-contenido").attr('class', 'container-contenido showNothing');
				$(".contenido-triangular .background-container").css("background-image", "none");
			} else {
				$(".contenido-triangular .container-contenido").attr('class', 'container-contenido showContenido1');
				var background = $(this).find("img.background");
				if (background.length > 0) {
					$(".contenido-triangular .background-container").css("background-image", "url(" + background.attr("src") + ")");
				} else {
					$(".contenido-triangular .background-container").css("background-image", "none");
				}
			}
		} else if ($(this).hasClass("contenido-round-2")) {
			if ($(".contenido-triangular .container-contenido").hasClass("showContenido2")) {
				$(".contenido-triangular .container-contenido").attr('class', 'container-contenido showNothing');
				$(".contenido-triangular .background-container").css("background-image", "none");
			} else {
				$(".contenido-triangular .container-contenido").attr('class', 'container-contenido showContenido2');
				var background = $(this).find("img.background");
				if (background.length > 0) {
					$(".contenido-triangular .background-container").css("background-image", "url(" + background.attr("src") + ")");
				} else {
					$(".contenido-triangular .background-container").css("background-image", "none");
				}
			}
		} else {
			if ($(".contenido-triangular .container-contenido").hasClass("showContenido3")) {
				$(".contenido-triangular .container-contenido").attr('class', 'container-contenido showNothing');
				$(".contenido-triangular .background-container").css("background-image", "none");
			} else {
				$(".contenido-triangular .container-contenido").attr('class', 'container-contenido showContenido3');
				var background = $(this).find("img.background");
				if (background.length > 0) {
					$(".contenido-triangular .background-container").css("background-image", "url(" + background.attr("src") + ")");
				} else {
					$(".contenido-triangular .background-container").css("background-image", "none");
				}
			}
		}

		$(".contenido-triangular").trigger("click");
	});
});
'use strict';

/*
==============================
Contenidos detalle desplegable
==============================
*/
$(function () {
    var $contenidosDesplegables = $('.contenido-desplegable'),
        swipers = [],
        timer_resize;

    $.fn.extend({
        updateSwiper: function updateSwiper() {
            var swiperId = parseInt($(this).attr('data-swiper-id'), 10),
                slideToIndex = 0,
                slidesPerView = swipers[swiperId].params.slidesPerView,
                slidesNum = $('.contenidos-block > .bottom-block .swiper-slide').length,
                freeMode = swipers[swiperId].params.freeMode,
                centeredSlides = swipers[swiperId].params.centeredSlides;

            if (window.innerWidth > media.mobile) {
                if (slidesNum <= 2) {
                    slidesPerView = 2;
                    slideToIndex = slidesNum == 2 ? 0.5 : 0;

                    centeredSlides = slidesNum == 2 ? false : true;
                    freeMode = true;
                    swipers[swiperId].lockSwipes();
                } else {
                    slidesPerView = window.innerWidth > media.tablet ? 3 : 2;
                    slideToIndex = 1;

                    centeredSlides = true;
                    freeMode = false;

                    if (window.innerWidth > media.tablet) swipers[swiperId].lockSwipes();else swipers[swiperId].unlockSwipes();
                }
            }
            // else if (window.innerWidth > media.mobile) {
            //     slidesPerView = 2;
            //     slideToIndex = $(this).find('.swiper-slide.active').index();

            //     freeMode = false;
            //     centeredSlides = true;
            //     swipers[swiperId].unlockSwipes();
            // }
            else {
                    slideToIndex = $(this).find('.swiper-slide.active').index();

                    freeMode = false;
                    centeredSlides = true;
                    swipers[swiperId].unlockSwipes();
                }

            swipers[swiperId].params.freeMode = freeMode;
            swipers[swiperId].params.centeredSlides = centeredSlides;
            swipers[swiperId].params.slidesPerView = slidesPerView;
            swipers[swiperId].update();
            swipers[swiperId].slideTo(slideToIndex);
        }
    });

    function checkAddContenidosDesplegablesSwiper() {
        $contenidosDesplegables.each(function (i) {
            var swiperCont = '#' + $(this).attr('id') + ' .swiper-container',
                $swiperWrapper = $(swiperCont).children('.swiper-wrapper');

            if ($swiperWrapper && $swiperWrapper.length > 0) {
                swipers[i] = new Swiper(swiperCont, {
                    spaceBetween: 0,
                    slidesPerView: 1.2,
                    preventClicksPropagation: false,
                    resistanceRatio: 0.5,
                    centeredSlides: true,
                    roundLengths: true,
                    initialSlide: $swiperWrapper.children('.active').index()
                });
                $(this).attr('data-swiper-id', i);
            }
        });
    }

    function checkHashURL() {
        var hash = window.location.hash;

        if (hash.length > 1 && hash.indexOf('contenido-desplegable-') > 0) {
            $(hash + ' .top-block a').trigger('click');
        }
        fixHeights.updateHeights();
    }

    function closeSwiper() {
        var $activeDesplegable = $('.contenido-desplegable.active'),
            $activeBottom = $('.contenidos-block > .bottom-block').length ? $('.contenidos-block > .bottom-block') : $('.contenido-desplegable.active > .bottom-block');

        if ($activeDesplegable.hasClass('active')) {
            $activeBottom.hide().promise().done(function () {
                if (window.innerWidth > media.mobile) {
                    $activeBottom.detach().appendTo($activeDesplegable);
                    if ($(window).scrollTop() != $activeDesplegable.offset().top - 10) {
                        $('html, body').animate({
                            scrollTop: $activeDesplegable.offset().top - 10
                        }, 'slow');
                    }
                }
                $activeDesplegable.removeClass('active');
            });
        }
    }

    if ($contenidosDesplegables.length > 0) {
        $('.contenido-desplegable .top-block a').on('click', function (e) {
            e.preventDefault();
            $(".contenidos-detalle-desplegable").find(".video-youtube.active iframe").remove();
            $(".contenidos-detalle-desplegable").find(".video-youtube.active .video-close").trigger("click");
            $(".contenidos-detalle-desplegable").find("a.swiper-close").show();
            var $desplegable = $(this).closest('.contenido-desplegable'),
                $activeDesplegable = $('.contenido-desplegable.active'),
                $activeBottom = $('.contenidos-block > .bottom-block').length ? $('.contenidos-block > .bottom-block') : $('.contenido-desplegable.active > .bottom-block');

            if (!$desplegable.hasClass('active')) {
                setHash('#' + $desplegable.attr('id'));
                $activeBottom.hide().promise().done(function () {
                    if (window.innerWidth > media.mobile) {
                        $activeBottom.detach().appendTo($activeDesplegable);
                        $desplegable.children('.bottom-block').detach().appendTo('.contenidos-block').show().promise().done(function () {
                            fixHeights.updateHeights();
                        });

                        if (window.innerWidth <= media.tablet || $desplegable.offset().top > $(document).scrollTop()) {
                            $('html, body').animate({
                                scrollTop: $('.contenido-desplegable').last().offset().top - 10
                            }, 'slow');
                        }
                    } else {
                        $('html, body').animate({
                            scrollTop: $desplegable.offset().top - 10
                        }, 'slow');
                        $desplegable.children('.bottom-block').show().promise().done(function () {
                            fixHeights.updateHeights();
                        });
                    }
                    $activeDesplegable.removeClass('active');
                    $desplegable.addClass('active');
                    if (typeof $desplegable.data('swiper-id') !== "undefined") $desplegable.updateSwiper();
                });
            } else {
                closeSwiper();
                setHash('#');
            }
            fixHeights.updateHeights();
        });

        $(document).on('click', '.swiper-close', function (e) {
            e.preventDefault();

            closeSwiper();
        });

        $(window).on('hashchange', function (e) {
            e.preventDefault();
            checkHashURL();
        });
        // $(window).on('resize', function() {
        //     if (!isMobile.any()) {
        //         clearTimeout(timer_resize);
        //         timer_resize = setTimeout(closeSwiper, 150);
        //     }
        // }).on( 'hashchange', function(e) {
        //     e.preventDefault();
        //     checkHashURL();
        // });

        checkAddContenidosDesplegablesSwiper();
        checkHashURL();
    }

    $(".contenidos-detalle-desplegable").find(".video-link").on("click", function () {
        $(".contenidos-detalle-desplegable").find("a.swiper-close").hide();
    });

    $(".contenidos-detalle-desplegable").find(".video-close").on("click", function () {
        $(".contenidos-detalle-desplegable").find("a.swiper-close").show();
    });
});
'use strict';

$(function () {
	if ($('.crossSelling-container').length > 0) {
		comprobarCrossSelling();

		$(window).resize(function () {
			comprobarCrossSelling();
		});
	}
});

function comprobarCrossSelling() {
	if (window.innerWidth < 800 && $('.crossSelling-container').find(".slick-list.draggable").length < 1) {
		$('.crossSelling-container').slick({
			dots: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false
		});
	} else if (window.innerWidth > 799 && $('.crossSelling-container').find(".slick-list.draggable").length > 0) {
		$('.crossSelling-container').slick('unslick');
	}
}
'use strict';

/*
==============================
Filter -> Filtro productos v1
==============================
*/

// force the plugin that aligns to do it's job
function pokeAlignerv1() {
    $(window).trigger('resize');
}

var _Filterv1 = function _Filterv1($sec) {
    var $filters = $sec.find('.filters'),
        $results = $sec.find('.filter-result-v1'),
        fTop = 85,
        fOldTop = 0,
        timer_resize;

    this.onReady = function () {
        if (window.innerWidth > media.desktop && !isMobile.any()) {
            fTop = $filters.offset().top - $sec.offset().top;
            fixedDesktopFiltersv1();
            checkShrinkFiltersv1();
        } else if (window.innerWidth <= media.mobile) {
            $filters.css('height', $filters.find('.filters-top').outerHeight() + 4);
            $filters.find('label').on('click touchend', function (e) {
                e.stopPropagation();
            });
            $filters.find('.filters-top, .apply-filters').on('click', fixedMobileFiltersv1);
        }

        $filters.find('.checkbox').on('change', checkboxClickedv1);

        $(window).on('scroll', function () {
            if (window.innerWidth > media.desktop && !isMobile.any()) {
                fixedDesktopFiltersv1();
            }
        }).on('resize', function () {
            if (window.innerWidth > media.mobile && window.innerWidth <= media.tablet) {
                $filters.attr('style', '');
            } else if (window.innerWidth > media.desktop && !isMobile.any()) {
                fixedDesktopFiltersv1();
            }
            $filters.css('opacity', 1);
        });
        $('.total-results').text($sec.find('.filter-result-v1').length);

        var cur_results = $sec.find('.filter-result-v1:visible').length;

        if (cur_results > 0) {
            $sec.find('.filter-results-v1 p.title.title-xs').show();
            $sec.find('.filter-results-v1 p.title.title-xs.txt-rojo').hide();
            $('.current-results').text(cur_results);
        } else {
            $sec.find('.filter-results-v1 p.title.title-xs').hide();
            $sec.find('.filter-results-v1 p.title.title-xs.txt-rojo').show();
        }
        $filters.css('opacity', 1);
    };

    function checkboxClickedv1() {
        var $fMenus = $filters.find('.filter-menu-v1'),
            filters = [];

        $fMenus.each(function () {
            var dfilters = $(this).find('.checkbox:checked'),
                fIndex = filters.length;

            if (dfilters.length > 0) {
                dfilters.prop('disabled', true);
                filters[fIndex] = filters[fIndex] || [];
                dfilters.each(function () {
                    filters[fIndex].push($(this).data('filter'));
                });
            }
        });

        $(this).parent().toggleClass('on');

        if (window.innerWidth <= media.mobile || window.innerWidth > media.desktop) {
            $('html, body').animate({
                scrollTop: $sec.offset().top
            }, 300);
        }

        setTimeout(function () {
            $results.fadeOut(400).promise().done(function () {
                if (filters.length > 0) filterResultsv1(filters);else $results.fadeIn().promise().done(pokeAlignerv1);

                var cur_results = $sec.find('.filter-result-v1:visible').length;

                if (cur_results > 0) {
                    $sec.find('.filter-results-v1 p.title.title-xs').show();
                    $sec.find('.filter-results-v1 p.title.title-xs.txt-rojo').hide();
                    $('.current-results').text(cur_results);
                } else {
                    $sec.find('.filter-results-v1 p.title.title-xs').hide();
                    $sec.find('.filter-results-v1 p.title.title-xs.txt-rojo').show();
                }
                $fMenus.find('.checkbox').prop('disabled', false);
            });

            // console.log('foo');
        }, 300);
    }

    function filterResultsv1(filters) {
        var filtered = [];

        $results.each(function () {
            var toFiltered = false,
                thisFilters = $(this).data('filters');

            if (thisFilters && thisFilters.length > 0) {
                for (var j = 0; j < filters.length; j++) {
                    for (var i = 0; i < thisFilters.length; i++) {
                        if (filters[j].indexOf(thisFilters[i]) > -1) {
                            toFiltered = true;
                            break;
                        } else {
                            toFiltered = false;
                        }
                    }
                    if (!toFiltered) break;
                }
            }

            if (toFiltered) {
                filtered.push($(this));
            }
        });

        for (var i = 0; i < filtered.length; i++) {
            filtered[i].fadeIn().promise().done(pokeAlignerv1);
        }
    }

    function fixedDesktopFiltersv1() {
        var fwidth = $filters.outerWidth(),
            sbottomPos = $sec.offset().top + $sec.outerHeight() - fTop - $(window).height(),
            isOverSec = $(document).scrollTop() <= $sec.offset().top,
            isBelowSec = isFilterHigherThanSecv1();

        if (isBelowSec) {
            if ($filters.hasClass('fixed')) {
                var rTop = $sec.height() - $filters.height() - fTop;
                // console.log(rTop);
                $filters.css({
                    'top': rTop,
                    'left': 0,
                    'position': 'relative'
                    // 'top': (isOverSec) ? fTop + ($sec.offset().top - $(document).scrollTop()) : fTop - $(document).scrollTop()
                });
                $sec.find('.filter-results-v1').css('margin-left', 0);

                $filters.removeClass('fixed');

                setTimeout(function () {
                    if (!$filters.hasClass('fixed')) {
                        // $filters.css({
                        //     position: 'static'
                        // });
                        //
                    }
                }, 800);
            }
        } else if (isOverSec) {
            if ($filters.hasClass('fixed')) {
                $filters.css({
                    position: 'static',
                    top: fTop
                });
                $sec.find('.filter-results-v1').css('margin-left', 0);
                $filters.removeClass('fixed');
            }
        } else if ($sec.offset().top <= $(document).scrollTop()) {
            if (!$filters.hasClass('fixed')) {
                $filters.css({
                    'top': isOverSec ? fTop + ($sec.offset().top - $(document).scrollTop()) : fTop - $(document).scrollTop()
                });
                $filters.css({
                    width: fwidth,
                    left: $filters.offset().left,
                    position: 'fixed',
                    top: fTop
                });
                $sec.find('.filter-results-v1').css('margin-left', fwidth);
                $filters.addClass('fixed');
            }
        }
    }

    function fixedMobileFiltersv1(e) {
        e.preventDefault();

        if (!$filters.hasClass('opened')) {
            $filters.css("height", $filters.find('.filters-top').outerHeight());
            $filters.css({
                height: $(window).height(),
                bottom: '0'
            });
            setTimeout(function () {
                $filters.addClass('opened').css({ 'overflow-y': 'scroll', 'overflow-x': 'hidden' });
                $filters.find('.filters-top .title-xs').slideDown();
                $('body').css('overflow-y', 'hidden');
                setTimeout(function () {
                    $filters.css('padding-top', $filters.find('.filters-top').outerHeight() + 4).find('.filter-menu-v1').fadeIn().promise().done(pokeAlignerv1);
                    onGlobalResize();
                }, 400);
            }, 800);
        } else {
            $filters.css({
                'overflow-y': 'visible',
                'overflow-x': 'visible'
            }).find('.filter-menu-v1').fadeOut(400);
            $filters.find('.filters-top .title-xs').slideUp(400);
            $('body').css('overflow-y', 'visible');

            setTimeout(function () {
                $filters.css({
                    bottom: '-3px',
                    height: $filters.find('.filters-top').outerHeight() + 4,
                    'padding-top': 0
                }).removeClass('opened');
            }, 400);
        }
    }

    function checkShrinkFiltersv1() {
        var isOverSec = $(document).scrollTop() <= $sec.offset().top,
            $flastMenu = $filters.find('.filter-menu-v1:not(.collapsed)').last();

        if ($filters.find('.filter-menu-v1:not(.collapsed)').length > 3 && isFilterHigherThanWindowv1()) {
            $flastMenu.addClass('collapsed');

            if (!$filters.find('.filters-layer').hasClass('big') && $filters.find('.filters-layer').height() + $flastMenu.height() < $filters.height()) {
                $filters.find('.filters-layer').css('width', $filters.width()).append($flastMenu);
            } else {
                $filters.addClass('big').find('.filters-layer').addClass('big').css('width', $filters.width() * 2).append($flastMenu);
            }
            checkShrinkFiltersv1();
        }
    }

    function isFilterHigherThanSecv1() {
        return $(document).scrollTop() - ($(window).height() - $filters.height() - fTop) >= $sec.offset().top + $sec.outerHeight() - fTop - $(window).height();
    }

    function isFilterHigherThanWindowv1() {
        return $sec.find('.filters').height() + fTop * 2 > $(window).height();
    }
};

$(function () {
    var $sec = $('.filtro-productos-v1');

    if ($sec && $sec.length > 0) {
        $sec.each(function () {
            var filter = new _Filterv1($(this));
            filter.onReady();
        });

        var check_img = new Image(),
            check_img1 = new Image(),
            check_img2 = new Image(),
            check_img3 = new Image();

        check_img.src = '/fbin/css/img/default/input-check.png';
        check_img1.src = '/fbin/css/img/default/input-check-hover.png';
        check_img2.src = '/fbin/css/img/default/input-check-checked.png';
        check_img3.src = '/fbin/css/img/default/input-check-hover-checked.png';
    }
});

/*
==============================
Filter -> Filtro productos v2
==============================
*/

// force the plugin that aligns to do it's job
function pokeAlignerv2() {
    $(window).trigger('resize');
}

var _Filterv2 = function _Filterv2($sec) {
    var $filters = $sec.find('.filters'),
        $results = $sec.find('.filter-result-v2'),
        fTop = 85,
        fOldTop = 0,
        allResults = [],
        timer_resize,
        paginaActual = 0;

    this.onReady = function () {
        $results.each(function () {
            allResults.push($(this));
        });

        paginaActual = 0;
        for (var i = 0; i < 50 && i < allResults.length; i++) {
            allResults[i].fadeIn().promise().done(pokeAlignerv2);
        }
        if (allResults.length > 49) {
            paginationFiltersv2(allResults.length, allResults);
        } else {
            $('.total-results').text(allResults.length);
        }
        if (window.innerWidth > media.desktop && !isMobile.any()) {
            fTop = $filters.offset().top - $sec.offset().top;
            var minHeight = $(".filters.big").height();
            minHeight = minHeight + 250;
            $(".filter-results-v2").css("min-height", minHeight + "px");
            fixedDesktopFiltersv2();
            checkShrinkFiltersv2();
        } else if (window.innerWidth <= media.mobile) {
            $filters.css('height', $filters.find('.filters-top').outerHeight() + 4);
            $filters.find('label').on('click touchend', function (e) {
                e.stopPropagation();
            });
            $filters.find('.filters-top, .apply-filters').on('click', fixedMobileFiltersv2);
        }

        $filters.find('.checkbox').on('change', checkboxClickedv2);

        $(window).on('scroll', function () {
            if (window.innerWidth > media.desktop && !isMobile.any()) {
                fixedDesktopFiltersv2();
            }
        }).on('resize', function () {
            if (window.innerWidth > media.mobile && window.innerWidth <= media.tablet) {
                $filters.attr('style', '');
            } else if (window.innerWidth > media.desktop && !isMobile.any()) {
                fixedDesktopFiltersv2();
            }
            $filters.css('opacity', 1);
        });
        $('.total-results').text($sec.find('.filter-result-v2').length);

        var cur_results = $sec.find('.filter-result-v2:visible').length;
        var text_cur_results = "1 - " + cur_results;

        if (cur_results > 0) {
            $sec.find('.filter-results-v2 p.title.title-xs').show();
            $sec.find('.filter-results-v2 p.title.title-xs.txt-rojo').hide();
            $('.current-results').text(text_cur_results);
        } else {
            $sec.find('.filter-results-v2 p.title.title-xs').hide();
            $sec.find('.filter-results-v2 p.title.title-xs.txt-rojo').show();
            $('.current-results').text(text_cur_results);
            if ($("#paginationFiltersContainer")) {
                $("#paginationFiltersContainer").remove();
            }
        }

        $filters.css('opacity', 1);
    };

    function checkboxClickedv2() {
        var $fMenus = $filters.find('.filter-menu-v2'),
            filters = [];

        $fMenus.each(function () {
            var dfilters = $(this).find('.checkbox:checked'),
                fIndex = filters.length;

            if (dfilters.length > 0) {
                dfilters.prop('disabled', true);
                filters[fIndex] = filters[fIndex] || [];
                dfilters.each(function () {
                    filters[fIndex].push($(this).data('filter'));
                });
            }
        });

        $(this).parent().toggleClass('on');

        if (window.innerWidth <= media.mobile || window.innerWidth > media.desktop) {
            $('html, body').animate({
                scrollTop: $sec.offset().top
            }, 300);
        }

        setTimeout(function () {
            $results.fadeOut(400).promise().done(function () {
                if (filters.length > 0) {
                    paginaActual = 0;
                    filterResultsv2(filters);
                } else {
                    paginaActual = 0;
                    for (var i = 0; i < 50 && i < allResults.length; i++) {
                        allResults[i].fadeIn().promise().done(pokeAlignerv2);
                    }
                    if (allResults.length > 49) {
                        paginationFiltersv2(allResults.length, allResults);
                    } else {
                        $('.total-results').text(allResults.length);
                    }
                    // $results.fadeIn().promise().done(pokeAlignerv2);
                }

                var cur_results = $sec.find('.filter-result-v2:visible').length;
                var text_cur_results = "1 - " + cur_results;

                if (cur_results > 0) {
                    $sec.find('.filter-results-v2 p.title.title-xs').show();
                    $sec.find('.filter-results-v2 p.title.title-xs.txt-rojo').hide();
                    $('.current-results').text(text_cur_results);
                } else {
                    $sec.find('.filter-results-v2 p.title.title-xs').hide();
                    $sec.find('.filter-results-v2 p.title.title-xs.txt-rojo').show();
                    $('.current-results').text(text_cur_results);
                    if ($("#paginationFiltersContainer")) {
                        $("#paginationFiltersContainer").remove();
                    }
                }
                $fMenus.find('.checkbox').prop('disabled', false);
            });

            // console.log('foo');
        }, 300);
    }

    function filterResultsv2(filters) {
        var filtered = [];

        $results.each(function () {
            var toFiltered = false,
                thisFilters = $(this).data('filters');

            if (thisFilters && thisFilters.length > 0) {
                for (var j = 0; j < filters.length; j++) {
                    for (var i = 0; i < thisFilters.length; i++) {
                        if (filters[j].indexOf(thisFilters[i]) > -1) {
                            toFiltered = true;
                            break;
                        } else {
                            toFiltered = false;
                        }
                    }
                    if (!toFiltered) break;
                }
            }

            if (toFiltered) {
                $(this).data("filteredDATA", true);
                filtered.push($(this));
            } else {
                $(this).data("filteredDATA", false);
            }
        });

        if (filtered.length > 50) {
            for (var i = 0; i < 50; i++) {
                filtered[i].fadeIn().promise().done(pokeAlignerv2);
            }
            paginationFiltersv2(filtered.length, filtered);
            // for (var i = 0; i < 50; i++) {
            //     filtered[i].fadeIn().promise().done(pokeAlignerv2);
            // }
            // if (filtered.length > 49){
            //     paginationFiltersv2(filtered.length, filtered);
            // }
            // else {
            //     $('.total-results').text(filtered.length);
            // }
        } else {
            $("#paginationFiltersContainer").remove();
            for (var i = 0; i < 50 && i < filtered.length; i++) {
                filtered[i].fadeIn().promise().done(pokeAlignerv2);
            }
            $('.total-results').text(filtered.length);
        }
    }

    function paginationFiltersv2(totalElem, elems) {
        if ($("#paginationFiltersContainer")) {
            $("#paginationFiltersContainer").remove();
        }
        var paginas = 5;
        var paginacionTotal = Math.ceil(totalElem / 50);
        $('.total-results').text(totalElem);
        $(".filter-results-v2").append('<div id="paginationFiltersContainer" class="g-sm-12 clearBoth"> <div class="filter-v2-pagination"><div class="paginationText-v2"><p>Página <strong class="pagActual">1</strong> de <strong>' + paginacionTotal + '</strong></p></div><ul class="paginationList-v2"><li class="prevArrow-v2 disabled-v2" data-page="prev">Anterior</li><li class="nextArrow-v2" data-page="next">Siguiente</li></ul></div></div>');
        if (paginacionTotal < 5) {
            paginas = paginacionTotal;
        }
        for (var i = 0; i < paginas; i++) {
            paginaActual = i + 1;
            if (i == 0) {
                $("#paginationFiltersContainer").find(".nextArrow-v2").before("<li class='active-v2 numberPag' data-page='" + paginaActual + "'>" + paginaActual + "</li>");
            } else {
                $("#paginationFiltersContainer").find(".nextArrow-v2").before("<li class='numberPag' data-page='" + paginaActual + "'>" + paginaActual + "</li>");
            }
        }
        paginacionClicked(paginacionTotal, elems);
    }

    function paginacionClicked(pagTotal, elems) {
        $("#paginationFiltersContainer li").bind("click", function (e) {
            e.preventDefault();
            $("html").animate({ scrollTop: 0 }, 1000);
            if ($(window).width() > 480) {
                $(".filters.big").css("position", "static");
            }
            var pagActiva = parseInt($("#paginationFiltersContainer li.active-v2").attr("data-page"));

            switch ($(this).data("page")) {
                case "prev":
                    if (pagActiva > 1) {
                        var paginaIrA = pagActiva - 1;
                        changePagina(paginaIrA, pagTotal, elems);
                    }
                    break;
                case "next":
                    if (pagTotal > pagActiva) {
                        var paginaIrA = pagActiva + 1;
                        changePagina(paginaIrA, pagTotal, elems);
                    }
                    break;
                default:
                    if (!$(this).hasClass("active-v2")) {
                        changePagina(parseInt($(this).attr("data-page")), pagTotal, elems);
                    }
                    break;
            }
        });
    }

    function changePagina(pagToGo, totalPag, elems) {
        $("#paginationFiltersContainer li:nth-child(2)").attr("data-page", pagToGo);
        $("#paginationFiltersContainer li:nth-child(2)").text(pagToGo);
        $("#paginationFiltersContainer .pagActual").text(pagToGo);
        if (pagToGo == totalPag) {
            $("#paginationFiltersContainer li").hide();
            $("#paginationFiltersContainer li:nth-child(2)").show();
            $("#paginationFiltersContainer li.nextArrow-v2").show();
            $("#paginationFiltersContainer li.prevArrow-v2").show();
        } else {
            $("#paginationFiltersContainer :nth-child(3)").hide();
            $("#paginationFiltersContainer :nth-child(4)").hide();
            $("#paginationFiltersContainer :nth-child(5)").hide();
            $("#paginationFiltersContainer :nth-child(6)").hide();
            for (var i = 3; i < 7; i++) {
                var pagIndex = pagToGo + i - 2;
                $("#paginationFiltersContainer li:nth-child(" + i + ")").attr("data-page", pagIndex);
                $("#paginationFiltersContainer li:nth-child(" + i + ")").text(pagIndex);
                $("#paginationFiltersContainer li:nth-child(" + i + ")").show();
                if (pagIndex == totalPag) {
                    break;
                }
            }
        }

        if (pagToGo == 1) {
            var resultForPag = 0;
        } else {
            var resultForPag = (pagToGo - 1) * 50;
        }
        $results.hide();
        var resultFinal = 0;
        for (var i = resultForPag; i < resultForPag + 50 && i <= elems.length - 1; i++) {

            elems[i].fadeIn().promise().done(pokeAlignerv2);
            resultFinal = i;
        }
        $('.current-results').text(resultForPag + 1 + " - " + (resultFinal + 1));
        if (pagToGo > 1 && pagToGo < totalPag) {
            $("#paginationFiltersContainer li.prevArrow-v2").removeClass("disabled-v2");
            $("#paginationFiltersContainer li.nextArrow-v2").removeClass("disabled-v2");
        } else if (pagToGo == totalPag) {
            $("#paginationFiltersContainer li.prevArrow-v2").removeClass("disabled-v2");
            $("#paginationFiltersContainer li.nextArrow-v2").addClass("disabled-v2");
        } else {
            $("#paginationFiltersContainer li.prevArrow-v2").addClass("disabled-v2");
            $("#paginationFiltersContainer li.nextArrow-v2").removeClass("disabled-v2");
        }
        $("#paginationFiltersContainer li.active-v2").removeClass("active-v2");
        $("#paginationFiltersContainer ul").find("[data-page='" + pagToGo + "']").addClass("active-v2");
    }

    function fixedDesktopFiltersv2() {
        var fwidth = $filters.outerWidth(),
            sbottomPos = $sec.offset().top + $sec.outerHeight() - fTop - $(window).height(),
            isOverSec = $(document).scrollTop() <= $sec.offset().top,
            isBelowSec = isFilterHigherThanSecv2();

        if (isBelowSec) {
            if ($filters.hasClass('fixed')) {
                var rTop = $sec.height() - $filters.height() - fTop;
                // console.log(rTop);
                $filters.css({
                    'top': rTop,
                    'left': 0,
                    'position': 'relative'
                    // 'top': (isOverSec) ? fTop + ($sec.offset().top - $(document).scrollTop()) : fTop - $(document).scrollTop()
                });
                $sec.find('.filter-results-v2').css('margin-left', 0);

                $filters.removeClass('fixed');

                setTimeout(function () {
                    if (!$filters.hasClass('fixed')) {
                        // $filters.css({
                        //     position: 'static'
                        // });
                        //
                    }
                }, 800);
            }
        } else if (isOverSec) {
            if ($filters.hasClass('fixed')) {
                $filters.css({
                    position: 'static',
                    top: fTop
                });
                $sec.find('.filter-results-v2').css('margin-left', 0);
                $filters.removeClass('fixed');
            }
        } else if ($sec.offset().top <= $(document).scrollTop()) {
            if (!$filters.hasClass('fixed')) {
                $filters.css({
                    'top': isOverSec ? fTop + ($sec.offset().top - $(document).scrollTop()) : fTop - $(document).scrollTop()
                });
                $filters.css({
                    width: fwidth,
                    left: $filters.offset().left,
                    position: 'fixed',
                    top: fTop
                });
                $sec.find('.filter-results-v2').css('margin-left', fwidth);
                $filters.addClass('fixed');
            }
        }
    }

    function fixedMobileFiltersv2(e) {
        e.preventDefault();

        if (!$filters.hasClass('opened')) {
            $filters.css("height", $filters.find('.filters-top').outerHeight());
            $filters.css({
                height: $(window).height(),
                bottom: '0'
            });
            setTimeout(function () {
                $filters.addClass('opened').css({ 'overflow-y': 'scroll', 'overflow-x': 'hidden' });
                $filters.find('.filters-top .title-xs').slideDown();
                $('body').css('overflow-y', 'hidden');
                setTimeout(function () {
                    $filters.css('padding-top', $filters.find('.filters-top').outerHeight() + 4).find('.filter-menu-v2').fadeIn().promise().done(pokeAlignerv2);
                    onGlobalResize();
                }, 400);
            }, 800);
        } else {
            $filters.css({
                'overflow-y': 'visible',
                'overflow-x': 'visible'
            }).find('.filter-menu-v2').fadeOut(400);
            $filters.find('.filters-top .title-xs').slideUp(400);
            $('body').css('overflow-y', 'visible');

            setTimeout(function () {
                $filters.css({
                    bottom: '-3px',
                    height: $filters.find('.filters-top').outerHeight() + 4,
                    'padding-top': 0
                }).removeClass('opened');
            }, 400);
        }
    }

    function checkShrinkFiltersv2() {
        var isOverSec = $(document).scrollTop() <= $sec.offset().top,
            $flastMenu = $filters.find('.filter-menu-v2:not(.collapsed)').last();

        if ($filters.find('.filter-menu-v2:not(.collapsed)').length > 3 && isFilterHigherThanWindowv2()) {
            $flastMenu.addClass('collapsed');

            if (!$filters.find('.filters-layer').hasClass('big') && $filters.find('.filters-layer').height() + $flastMenu.height() < $filters.height()) {
                $filters.find('.filters-layer').css('width', $filters.width()).append($flastMenu);
            } else {
                $filters.addClass('big').find('.filters-layer').addClass('big').css('width', $filters.width() * 2).append($flastMenu);
            }
            checkShrinkFiltersv2();
        }
    }

    function isFilterHigherThanSecv2() {
        return $(document).scrollTop() - ($(window).height() - $filters.height() - fTop) >= $sec.offset().top + $sec.outerHeight() - fTop - $(window).height();
    }

    function isFilterHigherThanWindowv2() {
        return $sec.find('.filters').height() + fTop * 2 > $(window).height();
    }
};

$(function () {
    var $sec = $('.filtro-productos-v2');

    if ($sec && $sec.length > 0) {
        $sec.each(function () {
            var filter = new _Filterv2($(this));
            filter.onReady();
        });

        var check_img = new Image(),
            check_img1 = new Image(),
            check_img2 = new Image(),
            check_img3 = new Image();

        check_img.src = '/fbin/css/img/default/input-check.png';
        check_img1.src = '/fbin/css/img/default/input-check-hover.png';
        check_img2.src = '/fbin/css/img/default/input-check-checked.png';
        check_img3.src = '/fbin/css/img/default/input-check-hover-checked.png';
    }
});

/*
==============================
Filter -> Filtro productos v3
==============================
*/

// force the plugin that aligns to do it's job
function pokeAlignerv3() {
    $(window).trigger('resize');
}

var _Filterv3 = function _Filterv3($sec) {
    var $filters = $sec.find('.filters'),
        $results = $sec.find('.filter-result-v3'),
        fTop = 85,
        fOldTop = 0,
        timer_resize;

    this.onReady = function () {

        $filters.find('.checkbox').on('change', checkboxClickedv3);

        $('.total-results').text($sec.find('.filter-result-v3').length);

        var cur_results = $sec.find('.filter-result-v3:visible').length;

        if (cur_results > 0) {
            $sec.find('.filter-results-v3 p.title.title-xs').show();
            $sec.find('.filter-results-v3 p.title.title-xs.txt-rojo').hide();
            $('.current-results').text(cur_results);
        } else {
            $sec.find('.filter-results-v3 p.title.title-xs').hide();
            $sec.find('.filter-results-v3 p.title.title-xs.txt-rojo').show();
        }
        $filters.css('opacity', 1);

        $(".filters-quit button").click(function () {
            $(".filter-menu-v3").find('input').each(function () {
                $(this).checkbox("uncheck");
            });
            checkboxClickedv3();
            $(".filters-quit button").prop('disabled', true);
        });
    };

    function checkboxClickedv3() {
        var $fMenus = $filters.find('.filter-menu-v3'),
            filters = [];

        $fMenus.each(function () {
            var dfilters = $(this).find('.checkbox:checked'),
                fIndex = filters.length;

            if (dfilters.length > 0) {
                dfilters.prop('disabled', true);
                filters[fIndex] = filters[fIndex] || [];
                dfilters.each(function () {
                    filters[fIndex].push($(this).data('filter'));
                });
            }
        });

        $(this).parent().toggleClass('on');

        if (window.innerWidth <= media.mobile || window.innerWidth > media.desktop) {
            $('html, body').animate({
                scrollTop: $sec.offset().top
            }, 300);
        }

        setTimeout(function () {
            $results.fadeOut(400).promise().done(function () {
                if (filters.length > 0) filterResultsv3(filters);else $results.fadeIn().promise().done(pokeAlignerv3);

                var cur_results = $sec.find('.filter-result-v3:visible').length;

                if (cur_results > 0) {
                    $sec.find('.filter-results-v3 p.title.title-xs').show();
                    $sec.find('.filter-results-v3 p.title.title-xs.txt-rojo').hide();
                    $('.current-results').text(cur_results);
                } else {
                    $sec.find('.filter-results-v3 p.title.title-xs').hide();
                    $sec.find('.filter-results-v3 p.title.title-xs.txt-rojo').show();
                }
                $fMenus.find('.checkbox').prop('disabled', false);
            });

            // console.log('foo');
        }, 300);
    }

    function filterResultsv3(filters) {
        var filtered = [];

        $results.each(function () {
            var toFiltered = false,
                thisFilters = $(this).data('filters');

            if (thisFilters && thisFilters.length > 0) {
                for (var j = 0; j < filters.length; j++) {
                    for (var i = 0; i < thisFilters.length; i++) {
                        if (filters[j].indexOf(thisFilters[i]) > -1) {
                            toFiltered = true;
                            break;
                        } else {
                            toFiltered = false;
                        }
                    }
                    if (!toFiltered) break;
                }
            }

            if (toFiltered) {
                filtered.push($(this));
            }
        });

        for (var i = 0; i < filtered.length; i++) {
            filtered[i].fadeIn().promise().done(pokeAlignerv3);
        }
    }

    function checkShrinkFiltersv3() {
        var isOverSec = $(document).scrollTop() <= $sec.offset().top,
            $flastMenu = $filters.find('.filter-menu-v3:not(.collapsed)').last();

        if ($filters.find('.filter-menu-v3:not(.collapsed)').length > 3 && isFilterHigherThanWindowv3()) {
            $flastMenu.addClass('collapsed');

            if (!$filters.find('.filters-layer').hasClass('big') && $filters.find('.filters-layer').height() + $flastMenu.height() < $filters.height()) {
                $filters.find('.filters-layer').css('width', $filters.width()).append($flastMenu);
            } else {
                $filters.addClass('big').find('.filters-layer').addClass('big').css('width', $filters.width() * 2).append($flastMenu);
            }
            checkShrinkFiltersv3();
        }
    }

    function isFilterHigherThanSecv3() {
        return $(document).scrollTop() - ($(window).height() - $filters.height() - fTop) >= $sec.offset().top + $sec.outerHeight() - fTop - $(window).height();
    }

    function isFilterHigherThanWindowv3() {
        return $sec.find('.filters').height() + fTop * 2 > $(window).height();
    }
};

$(function () {
    var $sec = $('.filtro-productos-v3');

    if ($sec && $sec.length > 0) {
        $sec.each(function () {
            var filter = new _Filterv3($(this));
            filter.onReady();
        });
    }

    $(".filtro-productos-v3").find(".filters-top").click(function () {
        if ($(this).hasClass("activeFilters")) {
            if ($(window).width() >= 480) {
                $(".filter-check-v3").css("height", "63px");
            } else {
                $(".filter-check-v3").css("height", "86px");
            }
            $(this).removeClass("activeFilters");
            $(this).find("i").removeClass("icon-uniE072");
            $(this).find("i").addClass("icon-uniE073");
        } else {
            $(".filter-check-v3").css("height", "100%");
            $(this).addClass("activeFilters");
            $(this).find("i").removeClass("icon-uniE073");
            $(this).find("i").addClass("icon-uniE072");
        }
    });

    $('.first-part').each(function () {
        if ($(this).offset().top < $(window).height()) {
            $(this).find(".imgLittleShow").animate({ 'opacity': '1' }, 1000);
            $(this).find(".imgBigShow").animate({ 'opacity': '1' }, 1500);
        }
    });

    $('.filter-menu-v3 li input').click(function () {
        var disabledFilters = true;
        $(this).each(function () {
            if ($(this).is(":checked")) {
                disabledFilters = false;
            }
        });
        if (disabledFilters) {
            $(".filters-quit button").prop('disabled', true);
        } else {
            $(".filters-quit button").prop('disabled', false);
        }
    });

    /* Every time the window is scrolled ... */
    $(window).scroll(function () {
        var bottom_of_window = $(window).scrollTop() + $(window).height();
        /* Check the location of each desired element */
        $('.first-part').each(function () {

            var bottom_of_object = $(this).offset().top + 150;
            /* If the object is completely visible in the window, fade it it */
            if (bottom_of_window > bottom_of_object) {
                $(this).find(".imgLittleShow").animate({ 'opacity': '1' }, 1000);
                $(this).find(".imgBigShow").animate({ 'opacity': '1' }, 1500);
            }
        });
    });
});
'use strict';

if ($('.fixed-rrss') && $('.fixed-rrss').length > 0) {
    var lastScrollTop = 0;
    $(window).on('scroll', function () {
        var scrollTop = $(this).scrollTop();

        if (scrollTop > lastScrollTop) {
            $('.fixed-rrss').addClass('s-hidden');
        } else if (scrollTop < lastScrollTop) {
            $('.fixed-rrss').removeClass('s-hidden');
        }

        lastScrollTop = scrollTop;
    }).load(function () {
        setTimeout(function () {
            $('.fixed-rrss').addClass('s-hidden');
        }, 3000);
    });
}
"use strict";

$(function () {
	if ($("section.fondoFijoBack").length > 0) {
		var backgroundFijo = $("section.fondoFijoBack").data("background");
		$("section.fondoFijoBack").css("background-image", "url(" + backgroundFijo + ")");
	}
});
'use strict';

$(function () {

    //==========================================================================
    // STATE
    //==========================================================================

    var $header = $('header.cabecera-landing').eq(0);
    var $sticky = $header.find('.sticky');
    var headerH = $header.outerHeight();
    var isShown = false;
    var canAnimate = checkCanAnimate();

    //==========================================================================
    // ENTRY POINT
    //==========================================================================

    init();

    //==========================================================================
    // INIT
    //==========================================================================

    //-----

    function init() {

        // if the page doesn't have the header with a sticky, abort
        if (!$sticky.length) return;

        // grab the title for the sticky header
        grabTitle($header, $sticky);

        // if we can animate, hide with transform instead of display
        if (canAnimate) $sticky.addClass('animation-hide').show();

        // on scroll show and hide the sticky
        $(window).on('scroll touchmove', updateStickyHeader);
    }

    //-----

    //==========================================================================
    // FUNCTIONS
    //==========================================================================

    //-----

    /**
     * Grab the title from the real header
     *
     * Populate the sticky header title with the text of the real header title.
     *
     * @param      {JQuery}  $header  The header.
     * @param      {JQuery}  $sticky  The sticky.
     */
    function grabTitle($header, $sticky) {
        $sticky.find('h1').text($header.find('h1').text());
    }

    //-----

    /**
     * Return true if the browser supports animations and is not <= IE 11.
     *
     * The IE restrictions are due to the fact that there's a a bug were
     * percentages in transforms used in animations are always treated as
     * pixels on windows 7.
     *
     * @see http://caniuse.com/#feat=css-animation
     */
    function checkCanAnimate() {
        var ieVersion = bbva.tools.getIEVersion();
        return !(ieVersion && ieVersion <= 11 || !checkAnimation());
    }

    //-----

    /**
     * Check if this browser supports CSS animation
     *
     * Ripped from MDN, check if the browser supports CSS animation looking
     * at the style properties of a div. Return whether it does.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Animations
     * /Detecting_CSS_animation_support
     */
    function checkAnimation() {

        // assume no animation, and define prefixes, de div, etc
        var domPrefixes = ['Webkit', 'Moz', 'O', 'ms', 'Khtml'],
            elm = document.createElement('div');

        // if the animation property is there, we're done
        if (defined(elm.style.animationName)) {
            return true;
        }

        // otherwise, try all prefixes and return if someone works
        return !!__(domPrefixes).find(function (prefix) {
            return defined(elm.style[prefix + 'AnimationName']);
        });
    }

    //-----

    //===== EVENTS =============================================================

    //-----

    /**
     * Show and hide the sticky header
     *
     * When the scroll is of more height than the header, show the sticky
     * header. When it's less or equal, hide it.
     */
    function updateStickyHeader() {

        var offset = $(window).scrollTop();

        // if the sticky should be shown
        if (!isShown && offset > headerH) {

            // show the sticky
            canAnimate ? $sticky.removeClass('slide-up').addClass('slide-down') : $sticky.show();

            // remember it's shown
            isShown = true;

            // we can be done now
            return;
        }

        // if the sticky should be hidden
        if (isShown && offset <= headerH) {

            canAnimate ? $sticky.removeClass('slide-down').addClass('slide-up') : $sticky.hide();

            // remember it's hidden
            isShown = false;
        }
    }

    //-----
});
'use strict';

$(function () {

    //==========================================================================
    // MODULE STATE
    //==========================================================================

    /**
     * The components.
     *
     * jQuery collection of section nodes that map to the component instances.
     *
     * @type       {jQuery}
     */
    var $components;

    //==========================================================================
    // ENTRY POINT
    //==========================================================================

    init();

    //==========================================================================
    // INIT
    //==========================================================================

    //-----

    function init() {
        // init module state
        initModuleState();

        // if there are no related components on the page, return
        if (!$components.length) return;

        // when the scroll height changes, update the value
        $window.on('resize', updateState);

        // for each component, do stuff
        __($components).each(manageComponent);
    }

    //-----

    //==========================================================================
    // FUNCTIONS
    //==========================================================================

    //-----

    function initModuleState() {
        $components = $('section.contenido-destacados-v2');
    }

    //-----

    function manageComponent(component) {
        var $component = $(component);
        var lastIsDesktop = $node.data('last-is-desktop');
        var currIsDesktop = window.innerWidth > media.tablet;

        adjustPictureToTopRightSide($component);

        $(window).on('resize', function (event) {
            if (currIsDesktop !== lastIsDesktop) {
                adjustPictureToTopRightSide($component, currIsDesktop, lastIsDesktop);
            }
        });

        $node.data('last-is-desktop', currIsDesktop);
    }

    //-----

    function adjustPictureToTopRightSide($component, currIsDesktop, lastIsDesktop) {

        var $picture = $component.find('picture');
        var $rightSideTop = $component.find('.right-side.top');

        if (lastIsDesktop) {
            // TODO: we can't use inline style because that would brack the
            // bg-center-img plugin...
        }
    }

    //-----
});
'use strict';

/*
==============================
Impacto video
==============================
*/
$(function () {
    if ($('.impacto-video video') && $('.impacto-video video').length > 0) {
        if (isMobile.any()) {
            $('.impacto-video video').remove();
            $('.impacto-video .img-block').css({
                height: '100%',
                width: '100%'
            }).children('img').centrarImagenVertical();
            onGlobalResize();
        } else {
            $('.impacto-video').each(function () {
                var $impacto = $(this),
                    $video = $impacto.find('video'),
                    DOMvideo = $video.get(0),
                    sources = [{ file: $video.data('mp4'), type: 'mp4' }, { file: $video.data('ogg'), type: 'ogg' }, { file: $video.data('webm'), type: 'webm' }];

                for (var i = 0; i < sources.length; i++) {
                    if (typeof sources[i].file != "undefined") {
                        $video.append('<source src="' + sources[i].file + '" type="video/' + sources[i].type + '">');
                    }
                }

                $video.append('Your browser does not support the video tag.');

                DOMvideo.autoplay = true;
                DOMvideo.load();
                DOMvideo.oncanplaythrough = function () {
                    $impacto.find('.img-block').hide();
                    DOMvideo.play();
                };
            });
        }
    }
});
"use strict";

$(function () {
    if ($("section.info-app").length > 0) {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (window.innerWidth < 481) {
            if (/android/i.test(userAgent)) {
                var hrefAndroid = $("section.info-app").find(".androidApp").attr("href");
                if ($("section.info-app").find(".androidApp").data("text")) {
                    var textAndroid = $("section.info-app").find(".androidApp").data("text");
                    $("section.info-app").find("h2").before("<a class='btn btn-destacado btn-lg descargaApp-infoApp' href='" + hrefAndroid + "'>" + textAndroid + "</a>");
                    $("section.info-app").find(".iphoneApp").remove();
                }
            }
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                var hrefIphone = $("section.info-app").find(".iphoneApp").attr("href");
                if ($("section.info-app").find(".iphoneApp").data("text")) {
                    var textIphone = $("section.info-app").find(".iphoneApp").data("text");
                    $("section.info-app").find("h2").before("<a class='btn btn-destacado btn-lg descargaApp-infoApp' href='" + hrefIphone + "'>" + textIphone + "</a>");
                    $("section.info-app").find(".androidApp").remove();
                }
            }
        }
    }
});
'use strict';

/*
==============================
Lightbox
==============================
*/

var autofitIframe = typeof autofitIframe !== "undefined" ? autofitIframe : function (a) {
    if (a.height === '95%') {
        if (!window.opera && document.all && document.getElementById) {
            a.style.height = a.contentWindow.document.body.scrollHeight;
        } else {
            if (document.getElementById) {
                a.style.height = 35 + a.contentDocument.body.scrollHeight + 'px';
            }
        }
    }
},
    getQuery = typeof getQuery !== "undefined" ? getQuery : function (myIFrameTieneParemetros) {
    var url = location.href,
        params = url.indexOf('?'),
        primerCaracterResult = myIFrameTieneParemetros > -1 ? '&' : '?',
        result = '';
    if (params !== -1) {
        var qs = url.substring(params + 1).split('&');
        for (var i = 0, result = primerCaracterResult; i < qs.length; i++) {
            qs[i] = qs[i].split('=');
            if (i > 0) {
                result += "&";
            }
            result += [qs[i][0]] + "=" + decodeURIComponent(qs[i][1]);
        }
    }
    return result;
},
    setIframeQueryStringParametersByClass = typeof setIframeQueryStringParametersByClass !== "undefined" ? setIframeQueryStringParametersByClass : function (iframeClass) {
    var myFrame = $('.' + iframeClass);
    $('.' + iframeClass).each(function () {
        setIframeQueryStringParameters(this);
    });
},
    setIframeQueryStringParameters = typeof setIframeQueryStringParameters !== "undefined" ? setIframeQueryStringParameters : function (myFrame) {
    var myFrameSrc = $(myFrame).attr('rel'),
        myIFrameTieneParemetros = myFrameSrc.indexOf('?'),
        url = myFrameSrc + getQuery(myIFrameTieneParemetros);
    $(myFrame).attr('src', url);
},
    listenerloadLBEnContainer = typeof listenerloadLBEnContainer !== "undefined" ? listenerloadLBEnContainer : function (containerHeight, containerWidth) {
    try {
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
        eventer(messageEvent, function (e) {
            if (e.origin == "https://www.bancomer.com" || e.origin == "http://www.bancomer.com") {
                ///Se evalua origen, por seguridad puede esperar respuesta desde http o https bancomer.com, los datos enviados estan en formato JSON
                if (e.data.action == "wizard") {
                    ///esta accion abre el lightBox con la pantalla de Ayuda Interactiva
                    loadLBEnContainer(e.data.url, containerHeight, containerWidth, "", ""); ///funccion define URL y tamaño de la ventana
                } else if (e.data.action == "cierra") {
                    ///esta accion cierra el lightBox y cambia la fuente del iframe de acceso
                    $('#IframeresetId').attr('src', e.data.url); ///cambiamos la fuente del iframe de acceso
                    $("#destino0" + " *").remove(); ///cerramos lightBox
                }
            }
        }, false);
    } catch (err) {
        console.log(err); ///en caso de error mandamos el mensaje la consola de errores de javascript
    }
},

// Para mantener las alturas de los iframes
SetIframeHeight = typeof SetIframeHeight !== "undefined" ? SetIframeHeight : function (an) {
    var isOldIE = navigator.userAgent.indexOf("MSIE") !== -1; // Detect IE10 and below
    var isIE8 = navigator.userAgent.indexOf("MSIE 8") !== -1;
    var isButonCheckPoints = "IframeresetId" == an;
    var applyResize = !(isIE8 && isButonCheckPoints);

    if (applyResize) {
        if (isOldIE) {
            $('#' + an).iFrameResize({
                heightCalculationMethod: 'max',
                interval: 32
            });
        } else {
            $('#' + an).iFrameResize({
                heightCalculationMethod: 'max',
                interval: 0
            });
        }
    } else if (isIE8) {
        $('#' + an).iFrameResize({
            heightCalculationMethod: 'max',
            interval: 32
        });
    }
},
    SetIframeHeightByClass = typeof SetIframeHeightByClass !== "undefined" ? SetIframeHeightByClass : function (an) {
    var isOldIE = navigator.userAgent.indexOf("MSIE") !== -1; // Detect IE10 and below
    if (isOldIE) {
        $('.' + an).iFrameResize({
            heightCalculationMethod: 'max',
            interval: 32,
            minHeight: 600
        });
    } else {
        $('.' + an).iFrameResize({
            heightCalculationMethod: 'max',
            interval: 0
        });
    }
};

if (typeof cargaLB !== "undefined") {
    $(function () {
        cargaLB();

        if (typeof siteBancomer === 'undefined') {
            listenerloadLBEnContainer(700, 450);
        }

        setIframeQueryStringParametersByClass('queryIframeParam');
        SetIframeHeightByClass('queryIframe');
    });
}
'use strict';

/*
==============================
Menu Horizontal gris
==============================
*/
$(function () {
    var timer_resize,
        menus = [],
        grayMenu = false;

    function checkAddSwiper() {
        $('.menu-horizontal').each(function (i) {
            var $wrapper = $(this).find('.swiper-wrapper'),
                swiper = false,
                id = $(this).attr('id');

            if ($wrapper.children().last().offset().top != $wrapper.children().first().offset().top) {
                $wrapper.removeClass('block');
                swiper = new Swiper('#' + id + ' .swiper-container', {
                    spaceBetween: 0,
                    slidesPerView: 'auto',
                    freeMode: true,
                    preventClicksPropagation: false,
                    resistanceRatio: 0.3,
                    roundLengths: true,
                    initialSlide: $wrapper.children('.active').index(),
                    onInit: checkBlurSwiper,
                    onSliderMove: checkBlurSwiper,
                    onTransitionEnd: checkBlurSwiper
                });
            }

            menus.push({
                elm: $(this),
                wrapper: $wrapper,
                swiper: swiper,
                id: id,
                activeSwiperSlide: 0
            });

            slideToActiveSwiper(menus[i]);
        });
    }

    function slideToActiveSwiper(menu) {
        if (menu.swiper && typeof menu.swiper !== "undefined") {
            var swiperTarget = menu.wrapper.children('.active'),
                swiperTargetIndex = swiperTarget.index(),
                slideToIndex = 0;

            if (swiperTargetIndex === 0 || swiperTargetIndex == menu.wrapper.children().length - 1) {
                menu.swiper.params.centeredSlides = false;
                slideToIndex = menu.wrapper.children('.active').index();
            } else if (window.innerWidth > media.mobile) {
                menu.swiper.params.centeredSlides = false;
                slideToIndex = menu.wrapper.children('.active').prev().index();
            } else {
                menu.swiper.params.centeredSlides = true;
                slideToIndex = menu.wrapper.children('.active').index();
            }
            menu.swiper.update();
            menu.swiper.slideTo(slideToIndex);
        }
        menu.wrapper.children().css('opacity', 1);
    }

    function checkBlurSwiper(swiper) {
        var $blurLeft = swiper.container.find('.swiper-blur-left'),
            $blurRight = swiper.container.find('.swiper-blur-right');

        if (swiper.isBeginning) {
            $blurLeft.css({
                'opacity': 0,
                'z-index': -1
            });
            $blurRight.css({
                'opacity': 1,
                'z-index': 2
            });
        } else if (swiper.isEnd) {
            $blurRight.css({
                'opacity': 0,
                'z-index': -1
            });
            $blurLeft.css({
                'opacity': 1,
                'z-index': 2
            });
        } else {
            swiper.container.find('.swiper-blur-left, .swiper-blur-right').css({
                'opacity': 1,
                'z-index': 2
            });
        }
    }

    function swiperSlideClicked(menu) {
        var dataTarget = menu.activeSwiperSlide.attr('data-target');

        if (dataTarget.length > 1) {
            var $dataTargetSiblings = $('#' + menu.id).closest('section').find('.' + $(dataTarget).attr('class').split(' ')[0]);

            $dataTargetSiblings.not(dataTarget).fadeOut(300).promise().done(function () {
                $(dataTarget).fadeIn(300, function () {
                    $dataTargetSiblings.removeClass('active');
                    $(dataTarget).addClass('active');
                    slideToActiveSwiper(menu);
                    setHash(dataTarget);
                    onGlobalResize();

                    var topPos = window.innerWidth > media.mobile ? 70 : menu.elm.hasClass('menu-wallet') ? -26 : 0;

                    $('html, body').animate({
                        scrollTop: menu.elm.offset().top - topPos
                    }, 300);
                });
            });
        }
        menu.wrapper.children('.swiper-slide').removeClass('active');
        menu.activeSwiperSlide.addClass('active');
        slideToActiveSwiper(menu);
    }

    function checkHashURL(evt) {
        var hash = window.location.hash,
            pathname = window.location.pathname;

        for (var j = 0; j < menus.length; j++) {
            menus[j].wrapper.children('.swiper-slide').each(function (i) {
                if (hash.length > 1 && (hash.indexOf('ficha-') > 0 || hash.indexOf('menu-') > 0) && $(this).attr('data-target') == hash) {
                    menus[j].activeSwiperSlide = $(this);
                    swiperSlideClicked(menus[j]);
                    return false;
                } else if ($(this).children('a').attr('href') == pathname) {
                    menus[j].activeSwiperSlide = $(this);
                    swiperSlideClicked(menus[j]);
                    return false;
                } else if (i == menus[j].wrapper.children('.swiper-slide').length - 1 && evt == 'hashchange') {
                    menus[j].activeSwiperSlidee = menus[j].wrapper.children('.swiper-slide').first();
                    swiperSlideClicked(menus[j]);
                    return false;
                }
            });
        }
    }

    function checkFixedMenu(menu) {
        var $fixedMenu = menu.elm.find('.menu-fixed'),
            $menuHorizontal = menu.elm,
            isInSectionScroll = $menuHorizontal.data('section-only') && $(document).scrollTop() + $menuHorizontal.height() - 45 > $menuHorizontal.closest('section').offset().top + $menuHorizontal.closest('section').height();

        if ($menuHorizontal.length > 0 && $menuHorizontal.offset().top <= $(document).scrollTop() && !$fixedMenu.hasClass('fixed') && !isInSectionScroll) {
            $fixedMenu.addClass('fixed');
            $fixedMenu.css('top', 0);
            setTimeout(function () {
                slideToActiveSwiper(menu);
            }, 400);
        } else if ($menuHorizontal.length > 0 && $menuHorizontal.offset().top > $(document).scrollTop() && $fixedMenu.hasClass('fixed')) {
            $fixedMenu.removeClass('fixed');
            setTimeout(function () {
                slideToActiveSwiper(menu);
            }, 400);
        } else if ($menuHorizontal.length > 0 && $fixedMenu.hasClass('fixed') && isInSectionScroll) {
            clearTimeout(timer_resize);
            timer_resize = setTimeout(function () {
                $fixedMenu.css('top', -$fixedMenu.outerHeight());
                setTimeout(function () {
                    $fixedMenu.removeClass('fixed');
                }, 400);
            }, 200);
        }
    }

    function fixMenuHeight(menu) {
        var $fixedMenu = menu.elm.find('.menu-fixed');

        if ($fixedMenu && $fixedMenu.length > 0) menu.elm.css('height', $fixedMenu.outerHeight());
        fixHeights.updateHeights();
    }

    if ($('.menu-horizontal').length > 0) {
        $(document).on('click', '.menu-horizontal .swiper-slide', function (e) {
            if ($(this).children('a').attr('href')[0] == "#") {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                var id = $(this).closest('.menu-horizontal').attr('id');

                for (var i = 0; i < menus.length; i++) {
                    if (menus[i].id == id) {
                        menus[i].activeSwiperSlide = $(this);
                        clearTimeout(timer_resize);
                        timer_resize = setTimeout(function () {
                            swiperSlideClicked(menus[i]);
                        }, 50);
                        return false;
                    }
                }
            }
        }).on('click', '.swiper-blur-right', function (e) {
            var id = $(this).closest('.menu-horizontal').attr('id');

            for (var i = 0; i < menus.length; i++) {
                if (menus[i].id == id) {
                    menus[i].swiper.slideNext();
                    return false;
                }
            }
        }).on('click', '.swiper-blur-left', function (e) {
            var id = $(this).closest('.menu-horizontal').attr('id');

            for (var i = 0; i < menus.length; i++) {
                if (menus[i].id == id) {
                    menus[i].swiper.slidePrev();
                    return false;
                }
            }
        });

        $(window).on('resize', function () {
            clearTimeout(timer_resize);
            timer_resize = setTimeout(checkAddSwiper, 100);
        }).on('hashchange', function (e) {
            e.preventDefault();
            checkHashURL('hashchange');
        }).on('scroll', function () {
            for (var i = 0; i < menus.length; i++) {
                checkFixedMenu(menus[i]);
            }
        });

        checkAddSwiper();
        checkHashURL('ready');

        for (var i = 0; i < menus.length; i++) {
            fixMenuHeight(menus[i]);
            checkFixedMenu(menus[i]);
            fixMenuHeight(menus[i]);

            if (!menus[i].elm.hasClass('menu-wallet')) grayMenu = true;else if (grayMenu) menus[i].elm.find('.menu-horizontal-gris').addClass('small-arrows');
        }
    }
});
/*
==============================
Modal - Moved to site.js
==============================
*/
// var modal_model = $('<section class="modal-v2">' +
//                 '<div class="modal-v2-anim">' +
//                     '<div class="modal-v2-header">' +
//                         '<div class="container">' +
//                             '<div class="vertical-align">' +
//                                 '<div class="align-middle">' +
//                                     '<a href="#" class="modal-v2-close"><i class="bbva-icon icon-glyph-4"></i></a>' +
//                                     '<h2 class="modal-v2-title title title-md"></h2>' +
//                                 '</div>' +
//                             '</div>' +
//                         '</div>' +
//                     '</div>' +
//                     '<div class="vertical-align">' +
//                         '<div class="align-modal">' +
//                             '<div class="modal-v2-container">' +
//                             '</div>' +
//                         '</div>' +
//                     '</div>' +
//                 '</div>' +
//                 '<div class="modal-v2-layer"></div>' +
//             '</section>'),
//     adding = false,
//     fakeScroll = false,
//     isWin = navigator.appVersion.indexOf("Win")!=-1;

// $(function() {
//     $('[rel^="lightbox"]').unbind('click');

//     $(document).on('click', '.modal-link, [rel^="lightbox"]', function(e) {
//         e.preventDefault();

//         appendModal($(this));
//     }).on('click', '.modal-v2-close', function(e) {
//         e.preventDefault();

//         hideModal($(this).closest('.modal-v2'));
//     }).on('click', '.modal-v2-layer', function() {
//         hideModal($(this).closest('.modal-v2'));
//     });
// });

// function appendModal(link) {
//     if (!adding) {
//         adding = true;
//         var href = link.attr('href'),
//             data = {
//                 title: link.attr('title'),
//                 txt: link.data('txt')
//             },
//             $modal = modal_model.clone();

//         $modal.find('.modal-v2-title').text(data.title);

//         $('main').append($modal);

//         if ($("body").height() > $(window).height()) {
//             fakeScroll = true;
//             $('body').css({
//                 'overflow': 'hidden'
//             });

//             if (isWin) {
//                 $('body').css({
//                     'padding-right': '17px'
//                 });
//             }
//         }

//         $modal.css('padding-top', $modal.find('.modal-v2-header').outerHeight()).addClass('show-modal');

//         setTimeout(function() {
//             if (href && href !== '#') {
//                 $modal.find('.modal-v2-container').append('<iframe onload="SetIframeHeightV2(\'modalIframe\')" frameborder="0" id="modalIframe" src="' + href + '" width="100%"></iframe>');
//                 var iframeSize = getModalIframeSize(link);

//                 if (iframeSize.width && !isMobile.any()) $('.modal-v2 .modal-v2-anim').css("width", (iframeSize.width));
//                 if (iframeSize.height) $('#modalIframe').css("height", iframeSize.height);
//                 // SetIframeHeightV2("modalIframe");
//             }
//             adding = false;
//         }, 650);
//     }
// }

// function getModalIframeSize(link) {
//     var rel = link.attr('rel'),
//         // data = {
//         //     width: link.data('width'),
//         //     height: link.data('height')
//         // },
//         rdata = {
//             width: '100%',
//             height: false
//         };

//     if (rel) {
//         rel = rel.split(';');
//         rel[1] = rel[1];
//         rel[2] = rel[2];

//         if ($(window).width() <= rel[1]) rel[1] = $(window).width() - 40;
//         if (rel[2] === 0) {
//             // SetIframeHeightV2("modalIframe");
//             rel[2] = false;
//         }
//         else if (rel[2] && rel[2].indexOf('%') > 0) {
//             rel[2] = parseInt(rel[2].split('%')[0]);
//             rel[2] = ($(window).height() * rel[2])/100 - 135;
//         }

//         rdata.width = rel[1];
//         rdata.height = rel[2];
//     }

//     // if (data.width && typeof data.width !== "undefined") rdata.width = data.width;
//     // if (data.height && typeof data.height !== "undefined" && data.height > 0) rdata.height = data.height;
//     // else if (!rel || rel.length === 0) SetIframeHeightV2("modalIframe");

//     return rdata;
// }

// function hideModal(modal) {
//     modal.removeClass('show-modal');

//     setTimeout(function() {
//         modal.remove();

//         if (fakeScroll) {
//             $('body').css({
//                 'overflow': 'visible'
//             });

//             if (isWin) {
//                 $('body').css({
//                     'padding-right': '0'
//                 });
//             }
//         }
//     }, 1000);
// }
"use strict";
// /**
//  * New Modal implmentation, calling it popup now :)
//  *
//  * This module intends to replace both the old lightbox and the new(ish)
//  * Modal.
//  */
// $(function() { // start module scope

// //==========================================================================
// // STATE
// //==========================================================================

// var $window            = $(window);
// var $document          = $(document);
// var $body              = $('body');
// var originalBodyScroll = $body.css('overflow') || 'auto';
// var transitionend      = transitionEnd();
// var $popupTemplate     = $(
//     '<section class="popup-root">' +
//         '<div class="popup-box">' +
//             '<header>' +
//                 '<h2>Ejemplo</h2>' +
//                 '<div class"close"></div>' +
//             '</header>' +

//             '<div class="popup-content"></div>' +
//             '<button class="popup-close"></button>' +
//         '</div>' +
//     '</section>'
// );

// //==========================================================================
// // ENTRY POINT
// //==========================================================================

// init();

// //==========================================================================
// // INIT
// //==========================================================================

// //-----

// /**
//  * Get things rolling
//  *
//  * This is the module's entry point, the only function that executes
//  * for the popup module. It binds the event that creates an iframe
//  * popup on `document`, using delegation, scoped to the nodes that
//  * matchs  `[rel^="lightbox"]`. It also tries to enter inside an iframe
//  * to do the same if it exists, the one inside `.header-buttons`.
//  */
// function init() {
//     // when a `[rel="lighbox"]` is clicked, create a pupup with iframe
//     $document.on('click.popup', '[rel^="lightbox"]', createPopupIframe);

//     // we need to support the buttons of an iframe in .header-buttons
//     // this will only work if it has already been created
//     var $iframe = $('.header-buttons').find('iframe');
//     if ($iframe) nodesThatCreatePopupsInsideIframe($iframe);

//     // we need to listen for some postMessage events for the login
//     $window.on('message onmessage', manageLoginPopups);

//     // we also need to take care of some postMessage stuff for bancomer
//     $window.on('message onmessage', manageBancomer);

//     // we want to publish some functions to load popups in other scenarios
//     window.bbva = window.bbva || {};
//     window.bbva.popup = {
//         create        : createPopup,
//         createFromUrl : createPopupFromUrl,
//         manage        : manageIframe
//     }
// }

// //-----

// //==========================================================================
// // FUNCTIONS
// //==========================================================================

// //-----

// /**
//  * Determine if the broser supports transtitions.
//  *
//  * Return the name of the event fired when a transition ends if transitions
//  * are supported, false otherwise.
//  *
//  * @return     {mixed}  Transition end event name or false.
//  */
// function transitionEnd() {
//     var el = document.createElement('div')

//     var names = __.create(null, {
//         WebkitTransition : 'webkitTransitionEnd',
//         MozTransition    : 'transitionend',
//         OTransition      : 'oTransitionEnd otransitionend',
//         transition       : 'transitionend'
//     });

//     for (var name in names) {
//         if (el.style[name] !== undefined) return names[name];
//     }

//     return false;
// }

// //-----

// /**
//  * Normalize a given url
//  *
//  * Create an `a` node and assign it the url as `href`. Tha makes the native
//  * web API normalize the url. For example, for "http://domain.com:33" and
//  * the url "/foo", the result is "http://domain.com/foo:33".
//  *
//  * If no url is given, return `undefined`.
//  *
//  * @param      {mixed}  url     The url string or a falsy value.
//  * @return     {mixed}  The normalized url string or undefined.
//  */
// function normalizeUrl(url) {
//     // if no url, return undefined
//     if (!url) return undefined;

//     // let native a node creation normalize for us
//     var a  = document.createElement('a');
//     a.href = url;

//     // return normalized url
//     return a.href;
// }

// //-----

// /**
//  * Parse a `rel` string and return the dimensions.
//  *
//  * A `rel` string has the format "lightbox;width;height", were both "width"
//  * and "height" are numbers or numbers followed by a percent sign.
//  *
//  * This function removes leading and trailing spaces and semi-colons,
//  * splits the result, and uses the second field as the width and the third
//  * as the height. It return an object with properties "width" and "height".
//  *
//  * @param      {string}  relAttr  The rel attribute string to parse.
//  * @return     {Object}  The dimensions object.
//  */
// function getDimensions(relAttr) {

//     if (!relAttr) return {};

//     // remove leading and trailing whitespace and ';', and split by ';'
//     var arr = __s(relAttr)
//         .replace(/\s/g, ';')
//         .trim(';')
//         .split(';')
//     ;

//     var width = arr[1] + 'px';
//     var height = arr[2] + 'px';

//     // return width and height
//     return {
//         width: width ? width.replace('%px', 'vw') : 'auto',
//         height: height ? height.replace('%px', 'vh'): 'auto'
//     }
// }

// //-----

// /**
//  * Creates an iframe to bw shown in the popup.
//  *
//  * Create an iframe, using as `src` the given url. Also, use the iframe to
//  * partially apply a "load" event listener.
//  *
//  * @param      {string}    url   The url.
//  * @return     {Function}  Listener for the iframe load event.
//  */
// function createIframe(url) {
//     var $iframe = $('<iframe>');

//     // register on load event
//     $iframe.on('load', __(popupIframeLoaded).partial(__, $iframe));

//     // add url
//     $iframe.attr('src', url);

//     // return the iframe
//     return $iframe;
// }

// //-----

// /**
//  * Show the popup.
//  *
//  * Add a class to style the popup into it's visible state, and disable the
//  * window scrolling.
//  *
//  * @param      {jQuery}  $popup  The popup
//  */
// function showPopup($popup) {
//     // show the modal and disable scroll on the main body
//     $popup.addClass('show-popup');
//     $body.css('overflow', 'hidden');
// }

// //-----

// function manageLoginPopups(event) {
//     var data = event.originalEvent.data;
//     var lang;
//     var mapMessageToPage;
//     var url;

//     console.log('>>>> called manageLoginPopups');

//     // return if not our data
//     if (!data || !__.contains(['clave', 'ayuda', 'consejo'], data)) return;

//     console.log('>>>> data = ', data);

//     // get the current language from the url
//     lang = document.location.href.replace(/\/+/g, '/').split('/')[2];

//     // return if not a country we're interested in
//     if (!__.contains(['es', 'en', 'fr', '']), lang) return;

//     // if lang, add forward slash
//     if (lang) lang = '/' + lang;

//     console.log('>>>> lang = ', lang);

//     // create a map from language to url segment
//     var mapMessageToPage = __.create(null, {
//         clave: 'forgot-pass',
//         ayuda: 'need-help',
//         consejo: 'login-tips'
//     });

//     // create the url for the popup
//     var url = lang + '/meta/' + mapMessageToUrl[data] + '.jsp';

//     console.log('>>>> url = ', url);

//     // create the popup
//     createPopupFromUrl(url);
// }

// //-----

// function createPopupFromUrl(url, width) {
//     var $iframe;
//     url = normalizeUrl(url);

//     // if no url, we're done
//     if (!url) return;

//     console.log('>>>> called createPopupFromUrl, url = ', url);

//     // create the iframe; registers events
//     $iframe = createIframe(url);

//     // create the popup
//     var $popup = createPopup($iframe, title, width, 'auto', true);

//     // avoid default behaviour
//     event.preventDefault();
// }

// //-----

// *
//  * Create the popup.
//  *
//  * Given some content, optionally a title, width, height and a flag to
//  * defer showing or not, first validate the content. If the content is not
//  * valid, don't do anything (@see the function validateNode for more info).
//  *
//  * Then, clone the popup template and, if a title was given, add it to the
//  * popup and add a class to style it's visibility. After that, apply with
//  * and height to the poup, if given. Also, register an event in the "close"
//  * button to close the popup when it's clicked, append the content to the
//  * popup, the popup to the body and, lastly, if the `deferShow` flag is not
//  * true, show the poup.
//  *
//  * @param      {mixed}    content     The content node.
//  * @param      {string}   title       The title.
//  * @param      {string}   width       The width with units included.
//  * @param      {string}   height      The height with units included.
//  * @param      {boolean}  deferShow   Flag wether to show the popup now.
//  * @return     {jQuery}  The pupup node.

// function createPopup(content, title, width, height, deferShow) {
//     var $node = validateNode(content);

//     // if invalid content, return
//     if (!$node) return;

//     var $popup    = $popupTemplate.clone();
//     var $popupBox = $popup.children('.popup-box');
//     var $close    = $popup.find('.popup-close');
//     var $header   =  $popup.find('header');
//     var styleStr  = '';

//     // if there's a title, add it and show the header
//     if (title) {
//         $header.children('h2').text(title);
//         $header.addClass('show-header');
//     }

//     // setup forced width and height
//     if (width) styleStr += 'width: ' + width + ';';
//     if (height) styleStr += 'height: ' + height + ';';
//     if (styleStr) $popupBox.attr('style', styleStr);
//     // register close event
//     $close.on('click', __(closePopup).partial($popup, __));

//     // append it to the popup
//     $popup.find('.popup-content').append($node);

//     // append the popup
//     $body.append($popup);

//     if (!deferShow) showPopup($popup);

//     return $popup;
// }

// //-----

// /**
//  * Validate the content of a popup.
//  *
//  * We want the content of a popup to be wrapped in jQuery, for convenience.
//  * If the poup was passed an Element
//  *
//  * @param      {(Function|boolean)}  content  The content
//  * @return     {(Function|boolean)}  { description_of_the_return_value }
//  */
// function validateNode(content) {
//     var $node = false;

//     // support only element nodes or jQuery objects
//     if (content instanceof Element) {
//         $node = $(content);
//     } else if (content instanceof jQuery) {
//         $node = content;
//     }

//     return $node;
// }

// //-----

// /**
//  * Close a popup.
//  *
//  * Given a popup node, close it, by removing the class that makes it visible,
//  * restoring the original overflow value, and removing the popup node from
//  * body.
//  *
//  * Do it on the `ontransitionend` event callback if transtions are supported.
//  *
//  * @param      {<type>}  $popup  The popup
//  */
// function closePopup($popup) {
//     $popup.removeClass('show-popup');

//     // remove instantly if no transition support,
//     if (!transitionend) {
//         $body.css('overflow', originalBodyScroll);
//         $popup.remove();
//         return;
//     }

//     // otherwise, remove when the transition ends
//     $popup.one(transitionend, function() {
//         $body.css('overflow', originalBodyScroll);
//         $popup.remove();
//     })
// }

// //-----

// /**
//  * Create poups when inner frame's `[rel^="lighbox"]` nodes are clicked
//  *
//  * The iframe must be same-origin. If it isnide, go inside, and add the
//  * event listener `createPopupIframe` that creates popups with iframes
//  * on all and every `[rel^="lighbox"]` node (event delegation is not
//  * working inside the iframe). Do this on the load event of the iframe if
//  * no content is found inside.
//  *
//  * @param      {jQuery}  $iframe  The iframe.
//  */
// function nodesThatCreatePopupsInsideIframe($iframe) {
//     // if the iframe is inside `.header-buttons`, we need to support it's
//     // inner `[rel^=lightbox nodes too]`; we assume it IS same-origin
//     var isSameOrigin = _checkSameOrigin($iframe.attr('src'));
//     var $rels;

//     // if the iframe is not sameOrigin, don't do anything
//     if (!isSameOrigin) return;

//     // has the iframe loaded?
//     if (_isIframeLoaded($iframe)) {
//         $rels = $iframe.contents().find('[rel^="lightbox"]');
//         $rels.on('click.popup', createPopupIframe);
//     }

//     // in any case, try to do it when it loads
//     $iframe.on('load', function() {
//         // now there should be rels
//         $rels = $iframe.contents().find('[rel^="lightbox"]');

//         // bind the event listener
//         $rels.on('click.popup', createPopupIframe);
//     });
// }

// //-----

// /**
//  * Given an iframe node, Support it's inner [rel^="lighbox"] nodes.
//  *
//  * First, discard parameters that are node `Element` or `jQuery` nodes.
//  * If they're ok, call the function that accounts for popup creation
//  * by parsing nodes inside the iframe.
//  *
//  * @param      {Function}  $iframe  The iframe
//  */
// function manageIframe($iframes) {
//     console.log('called manageIframe');

//     // support Element nodes
//     if ($iframes instanceof Element) $iframes = $($iframes);

//     // return in not a jQuery object
//     if (!($iframes instanceof jQuery)) return;

//     $iframes.each(function(i, iframe) {
//         var $iframe = $(iframe);

//         // continue if no src attribute (not an iframe)
//         if (!$iframe.attr('src')) return;

//         // get inside the iframe and bind events to nodes
//         nodesThatCreatePopupsInsideIframe($iframe);
//     });
// }

// //-----

// //===== EVENTS =============================================================

// //-----

// /**
//  * Create a popup iframe.
//  *
//  * If the `currentTarget` doesn't have an `href` or `data-url` attribute,
//  * don't do anything. Otherwise, create an iframe wwith that url normalized,
//  * and a popup with that iframe inside. The popup will not be visible until
//  * the iframe loads.
//  *
//  * @param      {object}  event   The jQuery event object.
//  */
// function createPopupIframe(event) {
//     // support disabling pupup plugin (can still be called through public API)
//     // also, don't run inside an iframe (so the plugin doesn't wok with the
//     // inner body)
//     if (window.popupPluginDisabled || window.self !== window.top) return;

//     var $node      = $(event.currentTarget);
//     var rel        = $node.attr('rel');
//     var title      = $node.attr('title');
//     var url        = normalizeUrl($node.attr('href') || $node.data('url'));
//     var dimensions = getDimensions(rel);
//     var $iframe;

//     // if no url, we're done
//     if (!url) return;

//     var deferShow = true;

//     // create the iframe; registers events
//     $iframe = createIframe(url);

//     // create the popup
//     var $popup = createPopup($iframe, title, dimensions.width,
//         dimensions.height, deferShow);

//     // avoid default behaviour
//     event.preventDefault();
// }

// //-----

// /**
//  * Resize the iframe and show the popup.
//  *
//  * Set the iframe height ourselves if the iframe is same-origin, otherwise,
//  * defer to iframeResizer.
//  *
//  * @param   {object}   event      The event
//  * @param   {jQuery}   $iframe    The iframe.
//  * @return  {boolean}  False. does what `PreventDefault` and
//  *                     `stopPropagation` do.
//  */
// function popupIframeLoaded(event, $iframe) {
//     // iframe resize
//     _setIframeHeight($iframe);

//     // show popup when the iframe loads
//     var $popup = $iframe.closest('.popup-root');
//     showPopup($popup);

//     // iframe load events don't bubble anyway, this is just descriptive
//     return false;
// }

// //-----

// /**
//  * Manage postMessage stuff for Bancomer
//  *
//  * Something about "wizard" and "cierra". Use an url that comes in the
//  * message to create a popup.
//  *
//  * @param      {object}  event   The event
//  */
// function manageBancomer(event) {
//     var e = event.originalEvent;
//     var isBancomer;
//     var width;
//     var height;
//     var url;

//     // if not the meesage we are intersed in, abort
//     if (!__.contains(['wizard', 'cierra'], e.data.action)) return;

//     // their origin must be inside ours (same-domain or subdomain)
//     if (!__s.include(window.location.host, e.origin)) return;

//     // if the action is "cierra", close the popup and return
//     if (e.data.action === 'cierra') {
//         var $close = $('.popup-root').find('.popup-close');
//         $close.length && $close.trigger('click');
//         return;
//     }

//     // else the action is "wizard"; is it bancomer?
//     isBancomer = __s.include(e.origin, '//www.bancomer.com');

//     // normalize url
//     url = normalizeUrl(e.data.url);

//     // if no url, do nothing
//     if (!url) return;

//     // set the dimensions
//     width = isBancomer ? '700px' : (window.LBEnContainerHeight || '70vw');
//     height = isBancomer ? '450px' : (window.LBEnContainerWidth || '70vw');

//     // create the popup from the url
//     e.data.url && createPopupFromUrl(url, width, height);
// }

// //-----

// }); // end module scope
"use strict";
"use strict";

$(function () {
	if ($("section.preguntas-frecuentes-coronita").length > 0) {
		$("section.preguntas-frecuentes-coronita").each(function () {
			var faqsthis = $(this);
			controlHeightsFaqs(faqsthis, faqsthis.find(".pf-faq.pf-active"));
			faqsthis.find(".pf-faq").on("click", function () {
				var clickthis = $(this);
				if (!clickthis.hasClass("pf-active")) {
					faqsthis.find(".pf-faq").find(".video-youtube.active .video-close").trigger("click");
					faqsthis.find(".pf-faq").find(".video-youtube.active iframe").remove();
					faqsthis.find(".pf-faq").removeClass("pf-active");
					clickthis.addClass("pf-active");
					controlHeightsFaqs(faqsthis, faqsthis.find(".pf-faq.pf-active"), true);
				}
			});
		});

		$(window).resize(function () {
			$("section.preguntas-frecuentes-coronita").each(function () {
				controlHeightsFaqs($(this), $(this).find(".pf-faq.pf-active"));
			});
		});
	}

	function controlHeightsFaqs(toTop, faqActiva, clicked) {
		if (window.innerWidth > 799) {
			if (clicked) {
				$('html, body').animate({
					scrollTop: toTop.offset().top
				}, 500);
			}
			var heightFaq = faqActiva.find(".pf-text-container").height() + 50;
			var heightQuestions = 0;
			toTop.find(".pf-faq").each(function () {
				heightQuestions = heightQuestions + $(this).innerHeight();
			});
			if (heightQuestions > heightFaq) {
				toTop.find(".pf-container").css("height", heightQuestions);
				toTop.find(".pf-faq.pf-active .pf-text-container").css("height", heightQuestions);
			} else {
				toTop.find(".pf-container").css("height", heightFaq);
			}
		} else {
			if (clicked) {
				$('html, body').animate({
					scrollTop: toTop.find(".pf-faq.pf-active").offset().top
				}, 500);
			}
			toTop.find(".pf-container").css("height", "auto");
		}
	}
});
"use strict";

$(function () {

	//==========================================================================
	// MODULE STATE
	//==========================================================================

	var $containerNewsHistory = $(".containerNewsHistory");

	//==========================================================================
	// ENTRY POINT
	//==========================================================================

	init();

	//==========================================================================
	// INIT
	//==========================================================================

	//-----

	function init() {
		if (!$containerNewsHistory) {
			return;
		}

		$containerNewsHistory.find(".containerMonth").click(function (event) {
			var elementMonth = $(this);
			if (elementMonth.hasClass("containerMonth-active")) {
				$(".containerMonth").children(".containerMonthNews").slideUp();
				elementMonth.removeClass("containerMonth-active");
			} else {
				$(".containerMonth").removeClass("containerMonth-active");
				$(".containerMonth").children(".containerMonthNews").slideUp();
				elementMonth.children(".containerMonthNews").slideDown();
				elementMonth.addClass("containerMonth-active");
			}
			setTimeout(function () {
				$('html, body').animate({
					scrollTop: elementMonth.offset().top
				}, 500);
			}, 200);
		});
	}

	//-----

	//==========================================================================
	// FUNCTIONS
	//==========================================================================

	//-----


	//===== Events =============================================================


	//-----
});
"use strict";

$(function () {
	if ($('.stepsModule-tab-container').length > 0) {
		comprobarstepsModule();

		$(window).resize(function () {
			comprobarstepsModule();
		});

		$(".stepsModule-tab").on("click", function () {
			if (!$(this).hasClass("stepsModule-tab-active")) {
				$(".stepsModule-tab").removeClass("stepsModule-tab-active");
				$(".stepsModule-content").removeClass("stepsModule-content-active");
				$(this).addClass("stepsModule-tab-active");
				var tabToShow = $(this).data("step-index");
				var indexTab = tabToShow;
				tabToShow = tabToShow + 1;
				$(".stepsModule-content:nth-of-type(" + tabToShow + ")").addClass("stepsModule-content-active");
				$('.stepsModule-tab-container').slick('slickGoTo', indexTab);
			}
		});

		// CREACIÓN DE IFRAME DE VIDEO EN STEPSMODULE
		$(".content-video-stepsModule").each(function () {
			var strVideo = $(this).data('video-id');
			var id = 'player-' + Date.now() + parseInt(Math.random() * 100000000);
			if (strVideo.indexOf("?") == -1) {
				$(this).append('<iframe id="' + id + '" src="https://www.youtube.com/embed/' + strVideo + '?rel=0&enablejsapi=1" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>');
			} else {
				$(this).append('<iframe id="' + id + '" src="https://www.youtube.com/embed/' + strVideo + '&rel=0&enablejsapi=1" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>');
			}
		});

		// FIN CREACIÓN DE IFRAME DE VIDEO EN STEPSMODULE
	}
});

function comprobarstepsModule() {
	if (window.innerWidth < 800 && $('.stepsModule-tab-container').find(".slick-list.draggable").length < 1) {
		$('.stepsModule-tab-container').slick({
			dots: false,
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			variableWidth: true
		});
	} else if (window.innerWidth > 799 && $('.stepsModule-tab-container').find(".slick-list.draggable").length > 0) {
		$('.stepsModule-tab-container').slick('unslick');
	}
}
'use strict';

/*
==============================
_Swiper logic & classes
==============================
*/
// _Swiper Object
var _Swiper = function _Swiper(id) {
    /*
    ---------------
    Public variables
    ---------------
    */

    this.params = {
        // DEFAULT swiper params
        preventClicks: false,
        preventClicksPropagation: false,
        resistanceRatio: 0.5,
        roundLengths: true,
        centeredSlides: true,
        paginationClickable: true,
        breakpoints: {},
        // Custom params
        lockSwiper: false,
        destroySwiper: false,
        slideToIndex: 0,
        autoplayDisableOnInteraction: false
    };

    this.status = 'toAdd';

    /*
    ---------------
    Public events
    ---------------
    */

    // Swiper instantiated, setup everything
    this.onReady = function () {
        $swiper = $('#' + id);
        initSwiperParams();
        this.onUpdate();
    };

    this.onResize = function () {
        this.onUpdate();
    };

    this.onUpdate = function () {
        var mediaParams = getMediaParams();

        if (mediaParams.destroySwiper && this.status != 'destroyed') this.status = 'toDestroy';else if (!mediaParams.destroySwiper && (this.status == 'destroyed' || this.status == 'toDestroy')) this.status = 'toAdd';

        switch (this.status) {
            case 'toAdd':
                addSwiper(mediaParams);
                break;
            case 'toUpdate':
                updateSwiper(mediaParams);
                break;
            case 'toDestroy':
                destroySwiper(mediaParams);
                break;
        }
    };

    /*
    ---------------
    Private variables & functions
    ---------------
    */

    var th = this,
        listid = false,
        $swiper,
        swiper,

    // Set params object values
    initSwiperParams = function initSwiperParams() {
        // Get breakpoints params
        var mobileData = getMediaData('swiper-mobile'),
            tabletData = getMediaData('swiper-tablet'),
            desktopData = getMediaData('swiper-desktop'),
            sParams = new _Swiper().params;

        // Params for all (desktop)
        th.params = $.extend({}, sParams, desktopData);

        // Remove breakpoints from object
        delete sParams.breakpoints;

        // <= Tablet params
        th.params.breakpoints[media.tablet] = $.extend({}, sParams, desktopData, tabletData);

        // <= Mobile params
        th.params.breakpoints[media.mobile] = $.extend({}, sParams, desktopData, tabletData, mobileData);
    },
        replicateLoopInIE = function replicateLoopInIE(mediaParams) {
        var toNextFn = swiper.slideNext.bind(swiper);
        var loop = setInterval(toNextFn, mediaParams.autoplay);

        // remove the internal swiper timeout
        swiper.autoplayTimeoutId && clearTimeout(swiper.autoplayTimeoutId);

        // reset the timer on slide change (pagintation, clicks, etc)
        swiper.on('slideChangeStart', function () {
            clearInterval(loop);
            loop = setInterval(toNextFn, mediaParams.autoplay);
        });
    },


    // Add swiper to the HTML
    addSwiper = function addSwiper(mediaParams) {
        swiper = new Swiper('#' + id + ' .swiper-container', th.params);
        listid = _Swipers.list.length - 1;
        th.status = 'toUpdate';
        th.onUpdate();
        swiper.on('onSlideChangeStart', slideChanged);

        if (document.documentMode < 10) {
            // the issue is that slidePrev() and slideNext() return fast
            // if `swiper.animating` is true, but IE9 does not support
            // animations, so the `transitionend` and `animationend`
            // events that should trigger the flag off don't fire, so
            // animating is always `true`
            //
            // the fix is to replace it if a nonwritable nonconfigurable
            // version set to false
            Object.defineProperty(swiper, 'animating', {
                configurable: false,
                enumerable: true,
                writable: false,
                value: false
            });

            // we need to do the same with `swiper.autoplaying' for the
            // autoplay loop to work
            Object.defineProperty(swiper, 'autoplaying', {
                configurable: false,
                enumerable: true,
                writable: false,
                value: false
            });

            // the loop is still not working properly, replicate with
            // setInterval
            replicateLoopInIE(mediaParams);
        }
    },


    // Update Swiper's params & status
    updateSwiper = function updateSwiper(mediaParams) {
        $swiper.removeClass('swiper-updated');

        var slideIndex = getSlideToIndex(mediaParams.slideToIndex);

        // Lock/Unlock swipes
        if (mediaParams.lockSwiper) {
            swiper.slideTo(0);
            swiper.lockSwipes();
            //$swiper.find('.swiper-wrapper, .swiper-wrapper .swiper-slide').removeAttr('style');
            $swiper.find('.swiper-slide-duplicate').remove();
        } else swiper.unlockSwipes();

        // Slide to certain index
        if (slideIndex) swiper.slideTo(slideIndex);

        // Run global onResize
        setTimeout(function () {
            onGlobalResize();
            $swiper.addClass('swiper-updated');
        }, 100);
    },


    // Destroy swiper
    destroySwiper = function destroySwiper() {
        if (swiper) {
            swiper.destroy();
            // $swiper.find('.swiper-wrapper, .swiper-slide').removeAttr('style');
            $swiper.find('.swiper-slide-active').removeClass('swiper-slide-active');
        }
        th.status = 'destroyed';
    },


    // Get the index of the slide we want to see
    getSlideToIndex = function getSlideToIndex(indexType) {
        var slidesNum = $swiper.find('.swiper-slide').length,
            slideActive = $swiper.find('.swiper-slide-active').index();

        switch (indexType) {
            case "middle":
                return slidesNum % 2 === 0 ? slidesNum / 2 - 0.5 : slidesNum / 2;
            case "active":
                return slideActive;
            default:
                return indexType ? indexType : false;
        }
    },


    // Get data from HTML
    getMediaData = function getMediaData(data) {
        data = $swiper.data(data);
        return data ? data : {};
    },


    // Get params depending on window size
    getMediaParams = function getMediaParams() {
        if (window.innerWidth > media.tablet) {
            return th.params;
        } else if (window.innerWidth > media.mobile) {
            return th.params.breakpoints[media.tablet];
        } else {
            return th.params.breakpoints[media.mobile];
        }
    },


    // Events
    slideChanged = function slideChanged(swiper) {
        var $iframe = $swiper.find('.swiper-slide-active iframe');

        // the iframe must be sameOrigin, and the node ust be there
        // at the BEGINNING of the slide change
        if ($iframe && $iframe.length && $iframe.attr('id')) {
            $iframe.get(0).contentDocument.location.reload(true);
        }
    };
};

// _Swipers Object
var _Swipers = {
    selector: '.swiper',
    list: [],
    onReady: function onReady() {
        var $swipers = $('.swiper');
        for (var i = 0; i < $swipers.length; i++) {
            var swiper = new _Swiper($swipers.eq(i).attr('id'));
            swiper.onReady();
            _Swipers.list.push(swiper);
        }
    },
    onResize: function onResize() {
        for (var i = 0; i < _Swipers.list.length; i++) {
            _Swipers.list[i].onResize();
        }
    }
};

// Initialize everything
$(function () {
    var timer_resize;

    if ($('.swiper').length > 0) {
        _Swipers.onReady();

        $(window).on('resize', function () {
            clearTimeout(timer_resize);
            timer_resize = setTimeout(_Swipers.onResize, 150);
        });
    }
});

if ($(".swiper").length > 0) {
    $(".swiper").trigger("click");
};
"use strict";

// COPIA DE LA TABLA1 PARA ENGLOBARLA EN UN DIV Y PONERLE SCROLL CUANDO NO ENTRE TODO EL CONTENIDO
$(function () {
	if ($(".tabla1").length > 0) {
		$(".tabla1").each(function () {
			$(this).after("<div style='overflow-x: auto;'><table class='tabla1'>" + $(this).html() + "</table></div>");
			$(this).remove();
		});
	}
});
"use strict";

$(document).ready(function () {

	function pestaniasWidth() {
		tamanioPestanias = 0;
		$(".menuTabBanner").find(".swiper-slide").each(function () {
			tamanioPestanias = tamanioPestanias + $(this).width();
		});
		return tamanioPestanias;
	}
	var tamanioPestanias = pestaniasWidth();
	if ($("section.tabs-banner-movil").length > 0) {
		var tabSwiperMobile;
		var $arrayIds;
		var hashAncla;

		(function () {

			// FIN CREACIÓN DE IFRAME DE VIDEO EN TABS

			//ANCHO DE LA PÁGINA PARA CONTROL DEL TRIÁNGULO AZUL FIN DE BLOQUE

			var widthTriangle = function widthTriangle() {
				var widthWindow = $(window).width() + "px";
				$(".tab-banner-content-END").css("border-right-width", widthWindow);
			};

			//FIN ANCHO DE LA PÁGINA PARA CONTROL DEL TRIÁNGULO AZUL FIN DE BLOQUE

			// CONTROL DE FLECHAS SUPERIORES DEL SWIPER
			var comprobacionNextPrev = function comprobacionNextPrev() {

				if ($(".menuTabBanner .swiper-button-prev").hasClass("swiper-button-disabled") && $(".menuTabBanner .swiper-button-next").hasClass("swiper-button-disabled")) {
					$(".menuTabBanner .prevTabBanner").hide();
					$(".menuTabBanner .nextTabBanner").hide();
				} else {
					if ($(".menuTabBanner .swiper-button-prev").hasClass("swiper-button-disabled")) {
						$(".menuTabBanner .prevTabBanner").css("opacity", "0.6");
						$(".menuTabBanner .prevTabBanner").css("pointer-events", "none");
					} else {
						$(".menuTabBanner .prevTabBanner").css("opacity", "1");
						$(".menuTabBanner .prevTabBanner").css("pointer-events", "initial");
					}

					if ($(".menuTabBanner .swiper-button-next").hasClass("swiper-button-disabled")) {
						$(".menuTabBanner .nextTabBanner").css("opacity", "0.6");
						$(".menuTabBanner .nextTabBanner").css("pointer-events", "none");
					} else {
						$(".menuTabBanner .nextTabBanner").css("opacity", "1");
						$(".menuTabBanner .nextTabBanner").css("pointer-events", "initial");
					}
				}
			};

			var sliderPrevView = function sliderPrevView() {
				$(".menuTabBanner .swiper-button-prev").trigger("click");
				comprobacionNextPrev();
			};

			var sliderNextView = function sliderNextView() {
				$(".menuTabBanner .swiper-button-next").trigger("click");
				comprobacionNextPrev();
			};

			// FIN CONTROL DE FLECHAS SUPERIORES DEL SWIPER


			// CONTROL DE FLECHAS INFERIORES, RECORREN DE 1 EN 1 LAS PESTAÑAS DEL SWIPER

			var disabledArrows = function disabledArrows(arrowToDisabled) {
				arrowToDisabled.css("opacity", "0.6");
				arrowToDisabled.css("pointer-events", "none");
			};

			var enabledArrows = function enabledArrows(arrowToEnabled) {
				arrowToEnabled.css("opacity", "1");
				arrowToEnabled.css("pointer-events", "initial");
			};

			// FIN IGUALAR ALTURA DE LOS TABS

			// COLOCAR ARROW TAB ACTUAL

			// function arrowSelected(){
			// 	$(".arrowSelected").css("left", $(".activeTab").offset().left+($(".activeTab").outerWidth()/2-11)+"px");
			// }

			// FIN COLOCAR ARROW TAB ACTUAL

			var containerHeightTabs = function containerHeightTabs(height) {
				$("section.tabs-banner-movil .menuTabBanner .container").height(height);
			};

			tabSwiperMobile = new Swiper('.tabs-banner-movil .swiper-container', {
				mode: 'horizontal',
				slidesPerView: 'auto',
				visibilityFullFit: true,
				cssWidthAndHeight: true,
				keyboardControl: true,
				calculateHeight: true,
				nextButton: ".swiper-button-next",
				prevButton: ".swiper-button-prev"
			});


			$(".menuTabBanner").find(".tabBanner0").addClass("activeTab");
			$(".menuTabBanner").addClass("dataActive");
			$(".tab-banner-content .tab-banner-content").eq(0).addClass("dataActive");
			// arrowSelected();

			$(".tab-banner-label").on("click", function (e) {
				console.log("width: " + $(window).width());
				if ($(window).width() < tamanioPestanias) {
					$('.swiper-wrapper').css({ "transform": "translate3d(-" + $("#" + $(this).attr("id")).position().left / 2 + "px, 0px, 0px)" });
				}
				var numElementBefore = $(".tab-banner-content .content-img .imgTab.dataActive").index();
				var numElement = $(this).index();
				if ($(this).index() === $(".swiper-slide.tab-banner-label").length - 1) {
					disabledArrows($(".tab-banner-content .nextTabBanner"));
					enabledArrows($(".tab-banner-content .prevTabBanner"));
				} else if ($(this).index() === 0) {
					disabledArrows($(".tab-banner-content .prevTabBanner"));
					enabledArrows($(".tab-banner-content .nextTabBanner"));
				} else {
					enabledArrows($(".tab-banner-content .prevTabBanner"));
					enabledArrows($(".tab-banner-content .nextTabBanner"));
				}
				$(".menuTabBanner .tab-banner-label").css("pointer-events", "none");
				$(".tab-banner-label").removeClass("activeTab");
				$(this).addClass("activeTab");
				$(".tab-banner-content .tab-banner-content.dataActive iframe").remove();
				var actualTab = $(".tab-banner-content .tab-banner-content.dataActive .content-video-banner-tab");
				var strVideo = actualTab.data('video-id');
				var id = 'player-' + Date.now() + parseInt(Math.random() * 100000000);
				if (strVideo.indexOf("?") == -1) {
					actualTab.append('<iframe id="' + id + '" src="https://www.youtube.com/embed/' + strVideo + '?rel=0&enablejsapi=1" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>');
				} else {
					actualTab.append('<iframe id="' + id + '" src="https://www.youtube.com/embed/' + strVideo + '&rel=0&enablejsapi=1" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>');
				}
				$(".tab-banner-content .tab-banner-content.dataActive").removeClass("dataActive");
				$(".tab-banner-content .tab-banner-content").eq(numElement).addClass("dataActive");
				$(".tab-banner-content .content-img .imgTab.dataActive").addClass("activePre");
				$(".tab-banner-content .content-img .imgTab").eq(numElement).addClass("dataActive");
				setTimeout(function () {
					$(".tab-banner-content .content-img .imgTab").eq(numElementBefore).removeClass("activePre dataActive");
					$(".menuTabBanner .tab-banner-label").css("pointer-events", "initial");
				}, 500);
				// arrowSelected();
			});

			// CREACIÓN DE IFRAME DE VIDEO EN TABS
			$(".content-video-banner-tab").each(function () {
				var strVideo = $(this).data('video-id');
				var id = 'player-' + Date.now() + parseInt(Math.random() * 100000000);
				if (strVideo.indexOf("?") == -1) {
					$(this).append('<iframe id="' + id + '" src="https://www.youtube.com/embed/' + strVideo + '?rel=0&enablejsapi=1" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>');
				} else {
					$(this).append('<iframe id="' + id + '" src="https://www.youtube.com/embed/' + strVideo + '&rel=0&enablejsapi=1" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>');
				}
			});

			widthTriangle();

			$(window).resize(function () {
				widthTriangle();
			});;

			comprobacionNextPrev();

			$(".menuTabBanner .prevTabBanner").on("click", function () {
				sliderPrevView();
			});

			$(".menuTabBanner .nextTabBanner").on("click", function () {
				sliderNextView();
			});

			;

			;
			// SI HAY MÁS DE UNA PESTAÑA SE CONTROLA

			if ($(".menuTabBanner .swiper-slide").length > 1) {
				(function () {
					var prevClick = function prevClick(arrow) {
						var tabToGo = parseInt($(".menuTabBanner .swiper-slide.activeTab").data("tab").split("b")[1]) - 1;
						$(".menuTabBanner .swiper-slide.tabBanner" + tabToGo).trigger("click");
						if (tabToGo === 0) {
							disabledArrows(arrow);
							enabledArrows($(".tab-banner-content .nextTabBanner"));
						} else {
							enabledArrows(arrow);
							enabledArrows($(".tab-banner-content .nextTabBanner"));
						}
					};

					var nextClick = function nextClick(arrow) {
						var tabToGo = parseInt($(".menuTabBanner .swiper-slide.activeTab").data("tab").split("b")[1]) + 1;
						$(".menuTabBanner .swiper-slide.tabBanner" + tabToGo).trigger("click");
						if (tabToGo === $(".menuTabBanner .swiper-slide").length - 1) {
							disabledArrows(arrow);
							enabledArrows($(".tab-banner-content .prevTabBanner"));
						} else {
							enabledArrows(arrow);
							enabledArrows($(".tab-banner-content .prevTabBanner"));
						}
					};

					disabledArrows($(".tab-banner-content .prevTabBanner"));

					$(".tab-banner-content .prevTabBanner").on("click", function () {
						prevClick($(this));
					});

					$(".tab-banner-content .nextTabBanner").on("click", function () {
						nextClick($(this));
					});
				})();
			}
			// SINO HAY MÁS DE UNA PESTAÑA, TODO SE QUEDA EN DISABLED
			else {
					disabledArrows($(".tab-banner-content .prevTabBanner"));
					disabledArrows($(".tab-banner-content .nextTabBanner"));
				}

			// FIN CONTROL DE FLECHAS INFERIORES


			// CONTROL DE TAB POR PARAMETRO
			$arrayIds = [];

			$('.swiper-slide.tab-banner-label').each(function () {
				var id = $(this).attr('id');
				$arrayIds.push(id);
			});
			hashAncla = window.location.hash.split("#")[1];

			if ($.inArray(hashAncla, $arrayIds) !== -1 && hashAncla !== "pestania1") {
				$("#" + hashAncla).trigger("click");
			}

			// FIN CONTROL DE TAB POR PARAMETRO

			// IGUALAR ALTURA DE LOS TABS
			$.fn.equalHeights = function () {
				var maxHeight = 0;
				// get the maximum height
				this.each(function () {
					var $this = jQuery(this);
					if ($this.height() > maxHeight) {
						maxHeight = $this.height();
					}
				});
				// set the elements height
				this.each(function () {
					var $this = jQuery(this);
					$this.height(maxHeight);
					containerHeightTabs(maxHeight);
				});
			};

			$(window).load(function () {
				$(".tab-banner-label").equalHeights();
			});

			$(window).resize(function () {
				$(".tab-banner-label").equalHeights();
				// arrowSelected();
			});
		})();
	}
});
'use strict';

$(function () {

    //==========================================================================
    // MODULE STATE
    //==========================================================================

    var $components;

    //==========================================================================
    // ENTRY POINT
    //==========================================================================

    init();

    //==========================================================================
    // INIT
    //==========================================================================

    //-----

    function init() {
        // init module state
        initModuleState();

        // if there are no related components on the page, return
        if (!$components.length) return;

        $components.on('click', '.video-link a, .video-close', function (e) {
            e.preventDefault();
            toggleYoutubeVideo($(this).closest('.video-youtube'));
        });

        if (isMobile.any() && $("section.preguntas-frecuentes-coronita").find(".video-youtube").length < 1) {
            // for each component, do stuff
            __($components).each(manageComponent);
        }
    }

    //-----

    //==========================================================================
    // FUNCTIONS
    //==========================================================================


    //-----

    function initModuleState() {
        $components = $('.video-youtube');
    }

    //-----

    function manageComponent(component) {
        var $component = $(component);

        $component.find('.video-link a').remove();

        // create the video
        var $videoIframe = $(getYoutubeVideo($component.closest('.video-youtube')));

        // append the video
        $component.find('.video-link').append($videoIframe);

        if (window.bbva && window.bbva.processVideoForDatalayer) {
            window.bbva.processVideoForDatalayer($videoIframe[0]);
        }
    }

    //-----

    function toggleYoutubeVideo(sec) {
        var $videoBlock = sec.children('.video-block');

        if (!$videoBlock.data('video-playing')) {
            sec.addClass('blurred');
            setTimeout(function () {
                sec.addClass('show-layer');

                setTimeout(function () {
                    sec.find('.video-container').append(getYoutubeVideo(sec));
                    sec.addClass('active');
                }, 600);
            }, 500);
            $videoBlock.data('video-playing', true);
        } else {
            sec.removeClass('active');
            setTimeout(function () {
                sec.removeClass('show-layer');
                setTimeout(function () {
                    sec.removeClass('blurred');

                    $videoBlock.find('.video-container').children().remove();
                }, 500);
            }, 400);
            $videoBlock.data('video-playing', false);
        }
    }

    //-----

    function getYoutubeVideo(sec) {
        var vwidth = sec.find('.video-block .container').width(),
            vheight = sec.find('.video-block .container').height();

        var id = 'player-' + Date.now() + parseInt(Math.random() * 100000000);
        var strVideo = sec.data('video-id');
        if (strVideo.indexOf("?") == -1) {
            return '<iframe id="' + id + '" src="https://www.youtube.com/embed/' + strVideo + '?rel=0&autoplay=1&enablejsapi=1" width="' + vwidth + '" height="' + vheight + '" frameborder="0" allowfullscreen></iframe>';
        } else {
            return '<iframe id="' + id + '" src="https://www.youtube.com/embed/' + strVideo + '&rel=0&autoplay=1&enablejsapi=1" width="' + vwidth + '" height="' + vheight + '" frameborder="0" allowfullscreen></iframe>';
        }
    }

    //-----
});